import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import imageCompression from 'browser-image-compression';
import heic2any from 'heic2any';
import { QRCodeSVG } from 'qrcode.react';
import api from '../../services/api';

const Icons = {
  User: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  MapPin: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  Glasses: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="6" cy="10" r="2"/><circle cx="18" cy="10" r="2"/><path d="M2 10s2-2 4-2c2 0 4 2 4 2s2-2 4-2 4 2 4 2"/></svg>,
  Search: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  Camera: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>,
  FileText: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  Dollar: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  Building: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 6h6M9 10h6M9 14h6M9 18h6"/></svg>,
  Phone: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.8 12.8 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.8 12.8 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
  Message: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 1 1-7.6-13.5h.8c4.3 0 7.9 3.5 7.7 7.7z"/></svg>,
  Plus: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Trash: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  Copy: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>,
  Smartphone: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>,
  Alert: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  
  // Formatos de Armação
  ShapeRound: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="10" cy="10" r="7"/><circle cx="30" cy="10" r="7"/><path d="M17 10h6"/></svg>,
  ShapeSquare: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="3" y="3" width="14" height="14" rx="2"/><rect x="23" y="3" width="14" height="14" rx="2"/><path d="M17 10h6"/></svg>,
  ShapeRect: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="2" y="5" width="16" height="10" rx="2"/><rect x="22" y="5" width="16" height="10" rx="2"/><path d="M18 10h4"/></svg>,
  ShapeOval: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><ellipse cx="10" cy="10" rx="8" ry="6"/><ellipse cx="30" cy="10" rx="8" ry="6"/><path d="M18 10h4"/></svg>,
  ShapeAviator: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M3 8c0-3 3-5 7-5 5 0 7 5 7 9 0 4-4 5-7 5-4 0-7-2-7-9z"/><path d="M23 8c0-3 3-5 7-5 5 0 7 5 7 9 0 4-4 5-7 5-4 0-7-2-7-9z"/><path d="M17 6h6"/></svg>,
  ShapeCat: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M2 6l5-4c4 0 9 4 9 9 0 4-4 5-7 5-4 0-7-3-7-10z"/><path d="M22 6l5-4c4 0 9 4 9 9 0 4-4 5-7 5-4 0-7-3-7-10z"/><path d="M16 8h8"/></svg>,
};

const itemPadrao = {
  paciente: '',
  receita: {
    od: { esf: '', cil: '', eixo: '', dnp: '', aco: '' },
    oe: { esf: '', cil: '', eixo: '', dnp: '', aco: '' },
    adicao: ''
  },
  lente: '',
  armacao: '',
  armacaoId: '',
  armacaoImagemUrl: '',
  armacaoImagemBlob: '',
  armacaoPreco: 0,
  armacaoAnexoUrl: '',
  armacaoAnexoIndex: null,
  cv: '',
  medidasArmacao: { aro: '', ponte: '', altura: '', diagonalMaior: '' },
  origemArmacao: 'Ótica',
  envioArmacao: 'Vai no malote',
  formatoArmacao: ''
};

const masks = {
  cpf: (v) => v.replace(/\D/g, '').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})/, '$1-$2').replace(/(-\d{2})\d+?$/, '$1'),
  cep: (v) => v.replace(/\D/g, '').replace(/^(\d{5})(\d)/, '$1-$2').slice(0, 9),
  phone: (v) => v.replace(/\D/g, '').replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2').slice(0, 15)
};

const formatters = {
  esf: (v) => { if (!v) return ''; const n = parseFloat(v.replace(',', '.')); return isNaN(n) ? v : `${n >= 0 ? '+' : ''}${n.toFixed(2).replace('.', ',')}`; },
  cil: (v) => { if (!v) return ''; const n = parseFloat(v.replace(',', '.')); return isNaN(n) ? v : `-${Math.abs(n).toFixed(2).replace('.', ',')}`; },
  eixo: (v) => { const n = parseInt(v); return isNaN(n) ? '' : `${Math.min(Math.max(n, 0), 180)}º`; },
  adicao: (v) => { if (!v) return ''; const n = parseFloat(v.replace(',', '.')); return isNaN(n) ? v : `+${Math.abs(n).toFixed(2).replace('.', ',')}`; }
};

const parseMoney = (val) => {
  if (!val) return 0;
  let v = String(val).replace(/[^0-9,.]/g, '').replace(',', '.');
  return isNaN(parseFloat(v)) ? 0 : parseFloat(v);
};

const formatCurrency = (v) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

const formatMoneyInput = (value) => {
  const number = Number(value || 0);

  if (!Number.isFinite(number)) return '0,00';

  return number.toFixed(2).replace('.', ',');
};

const safeParseUser = () => {
  try {
    return JSON.parse(localStorage.getItem('vizumUser')) || {};
  } catch {
    return {};
  }
};

const getEmpresaIdFromUser = (user = {}) => {
  const raw =
    user?.empresaId?._id ||
    user?.empresaId ||
    user?.empresa?._id ||
    user?.empresa?.id ||
    '';

  return raw ? String(raw) : '';
};

const montarParamsEmpresa = (empresaId) => {
  return empresaId ? { empresaId: String(empresaId) } : {};
};

const resolverArrayApi = (data, fallbackKey = '') => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.items)) return data.items;
  if (fallbackKey && Array.isArray(data?.[fallbackKey])) return data[fallbackKey];
  if (Array.isArray(data?.empresas)) return data.empresas;
  if (Array.isArray(data?.users)) return data.users;
  if (Array.isArray(data?.usuarios)) return data.usuarios;
  return [];
};

const mesmoId = (a, b) => {
  if (!a || !b) return false;
  return String(a) === String(b);
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const dataUrlToFile = async (dataUrl, filename = 'camera-anexo.jpg') => {
  const response = await fetch(dataUrl);
  const blob = await response.blob();

  return new File([blob], filename, {
    type: blob.type || 'image/jpeg'
  });
};

/* =============================================================
   PREVIEW SEGURO DE IMAGENS PRIVADAS
   Não acessa /pilotos direto.
   Busca a foto pela rota protegida com token:
   GET /ordens-servico/anexo-imagem?path=/pilotos/...
============================================================= */

function ProtectedImage({ src, alt, style, fallbackIcon, fallbackText = 'Foto' }) {
  const [objectUrl, setObjectUrl] = useState('');
  const [erro, setErro] = useState(false);
  const [loadingImg, setLoadingImg] = useState(false);

  useEffect(() => {
    let active = true;
    let createdUrl = '';

    async function carregar() {
      try {
        setErro(false);
        setObjectUrl('');

        if (!src) return;

        if (
          src.startsWith('data:') ||
          src.startsWith('blob:') ||
          src.startsWith('http://') ||
          src.startsWith('https://')
        ) {
          if (active) setObjectUrl(src);
          return;
        }

        setLoadingImg(true);

        const response = await api.get('/ordens-servico/anexo-imagem', {
          params: {
            path: src
          },
          responseType: 'blob'
        });

        createdUrl = URL.createObjectURL(response.data);

        if (active) {
          setObjectUrl(createdUrl);
        }
      } catch (error) {
        console.error('[ProtectedImage] Erro ao carregar imagem protegida:', error);

        if (active) {
          setErro(true);
        }
      } finally {
        if (active) {
          setLoadingImg(false);
        }
      }
    }

    carregar();

    return () => {
      active = false;

      if (createdUrl) {
        URL.revokeObjectURL(createdUrl);
      }
    };
  }, [src]);

  if (!src || erro || !objectUrl) {
    return (
      <div style={{ ...style, ...styles.protectedImageFallback }}>
        <div style={styles.protectedImageIcon}>
          {fallbackIcon || <Icons.Camera />}
        </div>
        <span>{erro ? 'Erro ao carregar' : loadingImg ? 'Carregando...' : fallbackText}</span>
      </div>
    );
  }

  return <img src={objectUrl} alt={alt} style={style} />;
}

const PhotoIllustrations = {
  FaceGlasses: () => (
    <svg width="30" height="30" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="16" cy="14" r="7" />
      <path d="M8.5 26c1.8-4 5-6 7.5-6s5.7 2 7.5 6" />
      <circle cx="12.5" cy="14" r="2.1" />
      <circle cx="19.5" cy="14" r="2.1" />
      <path d="M14.6 14h2.8" />
      <path d="M10.4 13.3 8.5 12" />
      <path d="M21.6 13.3 23.5 12" />
    </svg>
  ),
  Face: () => (
    <svg width="30" height="30" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="16" cy="14" r="7" />
      <path d="M8.5 26c1.8-4 5-6 7.5-6s5.7 2 7.5 6" />
      <path d="M13 14h.01" />
      <path d="M19 14h.01" />
      <path d="M13.5 17.5c1.6 1.1 3.4 1.1 5 0" />
    </svg>
  ),
  GlassesOnly: () => (
    <svg width="34" height="22" viewBox="0 0 44 26" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="13" r="7" />
      <circle cx="32" cy="13" r="7" />
      <path d="M19 13h6" />
      <path d="M5 10 1.5 8" />
      <path d="M39 10l3.5-2" />
    </svg>
  ),
  LensDetail: () => (
    <svg width="30" height="30" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="6" width="20" height="20" rx="4" />
      <circle cx="16" cy="16" r="6" />
      <path d="M20.5 20.5 25 25" />
      <path d="M13 13h6" />
      <path d="M13 17h4" />
    </svg>
  ),
  Prescription: () => (
    <svg width="30" height="30" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 4h9l5 5v17a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" />
      <path d="M19 4v6h6" />
      <path d="M12 15h8" />
      <path d="M12 19h8" />
      <path d="M12 23h5" />
    </svg>
  )
};

const PHOTO_STEPS = [
  {
    title: 'Cliente com óculos',
    subtitle: 'Rosto usando o óculos',
    Icon: PhotoIllustrations.FaceGlasses
  },
  {
    title: 'Cliente sem óculos',
    subtitle: 'Rosto sem armação',
    Icon: PhotoIllustrations.Face
  },
  {
    title: 'Somente o óculos',
    subtitle: 'Foto da armação',
    Icon: PhotoIllustrations.GlassesOnly
  },
  {
    title: 'Detalhe da lente',
    subtitle: 'Lente, montagem ou ajuste',
    Icon: PhotoIllustrations.LensDetail
  },
  {
    title: 'Dados da receita',
    subtitle: 'Receita ou comprovante',
    Icon: PhotoIllustrations.Prescription
  }
];

const ARMACAO_ANEXO_OCULOS_INDEX = 2;

const getPhotoStep = (index) => {
  return PHOTO_STEPS[index] || {
    title: `Foto extra ${index + 1}`,
    subtitle: 'Anexo adicional',
    Icon: Icons.Camera
  };
};


function SectionTitle({ icon, title, subtitle }) {
  return (
    <div style={styles.sectionTitleWrap}>
      <div style={styles.sectionIcon}>{icon}</div>
      <div>
        <div style={styles.sectionTitle}>{title}</div>
        {subtitle ? <div style={styles.sectionSubtitle}>{subtitle}</div> : null}
      </div>
    </div>
  );
}

function Field({ label, required, error, children, span2 }) {
  return (
    <div
      style={{
        ...styles.fieldWrap,
        ...(span2 ? styles.span2 : {}),
        ...(error ? styles.fieldWrapError : {})
      }}
    >
      <label style={{ ...styles.label, ...(error ? styles.labelError : {}) }}>
        {label} {required ? <span style={{ color: '#ef4444' }}>*</span> : null}
      </label>
      {children}
    </div>
  );
}

function ReceitaRow({ label, color, values, baseIndex, onChange, onEnter }) {
  return (
    <div style={styles.receitaRow}>
      <div style={{ ...styles.olhoBadge, background: color }}>{label}</div>
      {['esf', 'cil', 'eixo', 'dnp', 'aco'].map((field, i) => (
        <input
          key={field}
          data-idx={baseIndex + i}
          value={values[field] || ''}
          onChange={(e) => onChange(field, e.target.value)}
          onBlur={(e) => onChange(field, formatters[field] ? formatters[field](e.target.value) : e.target.value)}
          onKeyDown={(e) => onEnter(e, baseIndex + i)}
          style={styles.tdInput}
          placeholder={field === 'eixo' ? '0º' : '0,00'}
        />
      ))}
    </div>
  );
}

export default function OSForm({ onCancel, onSuccess }) {
  const todayStr = new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-');
  const statusOptions = ['Pedido da lente', 'Pedido realizado', 'No laboratório', 'Pronto na loja', 'Entregue'];
  const metodosPagamento = ['Dinheiro', 'PIX', 'Débito', 'Crédito'];

  const [empresas, setEmpresas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [loadingEmpresas, setLoadingEmpresas] = useState(false);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [loading, setLoading] = useState(false);
  const [, setLoadingCep] = useState(false);

  const [armacaoSuggestions, setArmacaoSuggestions] = useState([]);
  const [lenteSuggestions, setLenteSuggestions] = useState([]);
  const [showSuggestionsIndex, setShowSuggestionsIndex] = useState(null);
  const [showLenteSuggestionsIndex, setShowLenteSuggestionsIndex] = useState(null);
  const [isSearchingStock, setIsSearchingStock] = useState(false);
  const [isSearchingLente, setIsSearchingLente] = useState(false);

  const [compressing, setCompressing] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadMessage, setUploadMessage] = useState('');

  const [saveProgress, setSaveProgress] = useState(0);
  const [saveMessage, setSaveMessage] = useState('');
  const [saveDetail, setSaveDetail] = useState('');

  const [qrSessionId, setQrSessionId] = useState(null);
  const [showQRModal, setShowQRModal] = useState(false);

  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    empresaId: '',
    loja: '',
    vendedorId: '',
    vendedor: '',
    cliente: '',
    cpf: '',
    dataNascimento: '',
    whatsapp: '',
    cep: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    dataCompra: todayStr,
    dataEntrega: '',
    itens: [JSON.parse(JSON.stringify(itemPadrao))],
    status: 'Pedido da lente',
    statusmsg: 'Pendente',
    novoTextoRegistro: '',
    anexos: ['', '', '', '', ''],
    valorTotal: '',
    pagamentos: []
  });

  const previewUrlsRef = useRef({});
  const armacaoBlobUrlsRef = useRef({});
  const [localPreviewMap, setLocalPreviewMap] = useState({});

  const [novoPagamento, setNovoPagamento] = useState({
    metodo: 'Dinheiro',
    valor: '',
    parcelas: 1
  });

  useEffect(() => {
    const previewUrls = previewUrlsRef.current;
    const armacaoBlobUrls = armacaoBlobUrlsRef.current;

    return () => {
      Object.values(previewUrls || {}).forEach((url) => {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
      });

      Object.values(armacaoBlobUrls || {}).forEach((url) => {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, []);

  const definirPreviewLocal = useCallback((index, file) => {
    if (!file || !Number.isInteger(index)) return '';

    const previewUrl = URL.createObjectURL(file);
    const previewAnterior = previewUrlsRef.current[index];

    if (previewAnterior && previewAnterior.startsWith('blob:')) {
      URL.revokeObjectURL(previewAnterior);
    }

    previewUrlsRef.current[index] = previewUrl;
    setLocalPreviewMap((prev) => ({
      ...prev,
      [index]: previewUrl
    }));

    return previewUrl;
  }, []);

  const limparPreviewLocal = useCallback((index) => {
    const previewAtual = previewUrlsRef.current[index];

    if (previewAtual && previewAtual.startsWith('blob:')) {
      URL.revokeObjectURL(previewAtual);
    }

    delete previewUrlsRef.current[index];

    setLocalPreviewMap((prev) => {
      const next = { ...prev };
      delete next[index];
      return next;
    });
  }, []);

  const revogarArmacaoBlob = useCallback((index) => {
    const blobAtual = armacaoBlobUrlsRef.current[index];

    if (blobAtual && blobAtual.startsWith('blob:')) {
      URL.revokeObjectURL(blobAtual);
    }

    delete armacaoBlobUrlsRef.current[index];
  }, []);

  const carregarImagemArmacaoArquivo = useCallback(async (armacao = {}) => {
    if (!armacao?._id) {
      return {
        file: null,
        objectUrl: ''
      };
    }

    try {
      const response = await api.get(`/api/armacoes/${armacao._id}/imagem`, {
        responseType: 'blob'
      });

      const blob = response.data;
      const mime = blob?.type || 'image/webp';
      const extensao = mime.includes('png') ? 'png' : mime.includes('jpeg') || mime.includes('jpg') ? 'jpg' : 'webp';
      const refLimpa = String(armacao.ref || armacao._id || Date.now())
        .replace(/[^a-zA-Z0-9-_]/g, '')
        .slice(0, 42);

      const file = new File(
        [blob],
        `armacao-${refLimpa || Date.now()}.${extensao}`,
        { type: mime }
      );

      return {
        file,
        objectUrl: URL.createObjectURL(blob)
      };
    } catch (error) {
      console.error('[OSForm] Erro ao carregar imagem da armação:', error);

      return {
        file: null,
        objectUrl: ''
      };
    }
  }, []);

  const userLogado = useMemo(() => safeParseUser(), []);
  const empresaIdAtual = useMemo(() => getEmpresaIdFromUser(userLogado), [userLogado]);

  const empresaSelecionada = useMemo(() => {
    return empresas.find((emp) => {
      return (
        mesmoId(emp?._id, form.empresaId) ||
        mesmoId(emp?.id, form.empresaId) ||
        String(emp?.codigoLoja || '').trim() === String(form.loja || '').trim()
      );
    }) || null;
  }, [empresas, form.empresaId, form.loja]);

  const empresasAtivas = useMemo(() => {
    return empresas.filter((emp) => emp.ativo !== false);
  }, [empresas]);

  const lojaTopoCodigo = empresaSelecionada?.codigoLoja || form.loja || 'Selecione';
  const lojaTopoNome = empresaSelecionada?.unidade || empresaSelecionada?.nome || 'Nenhuma unidade selecionada';

  const vendedoresDisponiveis = useMemo(() => {
    if (!form.empresaId && !form.loja) return [];

    return usuarios.filter((user) => {
      const ativo = user.ativo !== false;
      const tipoValido = ['vendedor', 'admin'].includes(String(user.tipo || '').toLowerCase());

      const userEmpresaId =
        user?.empresaId?._id ||
        user?.empresaId ||
        user?.empresa?._id ||
        user?.empresa?.id ||
        '';

      const mesmaEmpresa = form.empresaId && mesmoId(userEmpresaId, form.empresaId);
      const mesmaLojaFallback = form.loja && String(user.loja || '').trim() === String(form.loja || '').trim();

      return ativo && tipoValido && (mesmaEmpresa || mesmaLojaFallback);
    });
  }, [usuarios, form.empresaId, form.loja]);

  const uploadAnexoParaServidor = useCallback(async (file, options = {}) => {
    const { index = null, origem = 'os-form' } = options;

    if (!file) return null;

    try {
      setCompressing(true);
      setUploadProgress(0);
      setUploadMessage('Analisando imagem...');

      let fileToProcess = file;
      const nomeOriginal = file.name || `anexo-${Date.now()}.jpg`;
      const fileExtension = nomeOriginal.split('.').pop().toLowerCase();
      const isHeic =
        file.type === 'image/heic' ||
        file.type === 'image/heif' ||
        fileExtension === 'heic' ||
        fileExtension === 'heif';

      if (isHeic) {
        setUploadMessage('Convertendo HEIC para JPG...');
        setUploadProgress(15);

        const convertedBlob = await heic2any({
          blob: file,
          toType: 'image/jpeg',
          quality: 0.82
        });

        const blob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;

        fileToProcess = new File(
          [blob],
          nomeOriginal.replace(/\.(heic|heif)$/i, '.jpg'),
          { type: 'image/jpeg' }
        );

        setUploadProgress(35);
      }

      setUploadMessage('Reduzindo tamanho da imagem...');

      const finalFile = await imageCompression(fileToProcess, {
        maxSizeMB: 0.55,
        maxWidthOrHeight: 1600,
        initialQuality: 0.82,
        useWebWorker: true,
        onProgress: (p) => {
          const base = isHeic ? 35 : 5;
          const limite = isHeic ? 68 : 70;
          const progress = base + (Number(p || 0) / 100) * (limite - base);
          setUploadProgress(Math.min(70, Math.round(progress)));
        }
      });

      setUploadMessage('Enviando imagem para a VPS...');
      setUploadProgress((prev) => Math.max(prev, 72));

      const formData = new FormData();
      const empresaIdUpload = form.empresaId || empresaSelecionada?._id || empresaSelecionada?.id || empresaIdAtual || '';

      formData.append('imagem', finalFile, finalFile.name || `anexo-${Date.now()}.jpg`);
      formData.append('origem', origem);

      if (empresaIdUpload) formData.append('empresaId', empresaIdUpload);
      if (form.loja) formData.append('loja', form.loja);

      const response = await api.post('/ordens-servico/upload-anexo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (event) => {
          if (!event.total) return;

          const percent = Math.round((event.loaded * 100) / event.total);
          const progress = 72 + percent * 0.23;
          setUploadProgress(Math.min(95, Math.round(progress)));
        }
      });

      const imageUrl = response.data?.url || response.data?.imageUrl;

      if (!imageUrl) {
        throw new Error('Servidor não retornou o caminho da imagem.');
      }

      if (Number.isInteger(index)) {
        setForm((prev) => {
          const newAnexos = [...prev.anexos];
          newAnexos[index] = imageUrl;
          return { ...prev, anexos: newAnexos };
        });
      }

      setUploadProgress(100);

      const sizeKB = response.data?.sizeKB;
      setUploadMessage(sizeKB ? `Imagem salva na VPS (${sizeKB} KB).` : 'Imagem salva na VPS.');

      await delay(250);

      return imageUrl;
    } catch (error) {
      console.error('Erro ao enviar anexo:', error);
      alert(error.response?.data?.error || error.message || 'Erro ao carregar imagem.');
      return null;
    } finally {
      setTimeout(() => {
        setCompressing(false);
        setUploadProgress(0);
        setUploadMessage('');
      }, 350);
    }
  }, [form.empresaId, form.loja, empresaSelecionada, empresaIdAtual]);

  useEffect(() => {
    if (!form.empresaId && !form.loja && empresas.length > 0) {
      const primeiraAtiva = empresas.find((emp) => emp.ativo !== false) || empresas[0];

      setForm((prev) => ({
        ...prev,
        empresaId: primeiraAtiva?._id || primeiraAtiva?.id || '',
        loja: primeiraAtiva?.codigoLoja || primeiraAtiva?._id || ''
      }));
    }
  }, [empresas, form.empresaId, form.loja]);

  useEffect(() => {
    if (!form.empresaId && !form.loja) return;

    const vendedorAindaExiste = vendedoresDisponiveis.some((user) => {
      return (
        mesmoId(user?._id, form.vendedorId) ||
        String(user.nomeCompleto || '').trim() === String(form.vendedor || '').trim()
      );
    });

    if (!vendedorAindaExiste) {
      const primeiro = vendedoresDisponiveis[0];

      setForm((prev) => ({
        ...prev,
        vendedorId: primeiro?._id || '',
        vendedor: primeiro?.nomeCompleto || primeiro?.nome || ''
      }));
    }
  }, [form.empresaId, form.loja, form.vendedor, form.vendedorId, vendedoresDisponiveis]);

  useEffect(() => {
    let interval;
    let consultando = false;
    let cancelado = false;

    const inserirAnexoNoPrimeiroEspaco = (imageUrl) => {
      if (!imageUrl) return;

      setForm((prev) => {
        const newAnexos = [...prev.anexos];
        const vazioIndex = newAnexos.findIndex((item) => !item);

        if (vazioIndex >= 0) {
          newAnexos[vazioIndex] = imageUrl;
        } else {
          newAnexos.push(imageUrl);
        }

        return { ...prev, anexos: newAnexos };
      });
    };

    const processarImagensDaCamera = async (images = []) => {
      for (let i = 0; i < images.length; i++) {
        if (cancelado) return;

        const image = images[i];

        if (!image) continue;

        if (typeof image === 'string' && image.startsWith('data:image/')) {
          const file = await dataUrlToFile(
            image,
            `camera-${qrSessionId || 'os'}-${Date.now()}-${i}.jpg`
          );

          const imageUrl = await uploadAnexoParaServidor(file, {
            origem: 'camera-celular'
          });

          inserirAnexoNoPrimeiroEspaco(imageUrl);
        } else {
          inserirAnexoNoPrimeiroEspaco(image);
        }
      }
    };

    if (showQRModal && qrSessionId) {
      interval = setInterval(async () => {
        if (consultando) return;

        consultando = true;

        try {
          const response = await api.get(`/ordens-servico/api/sync-camera/${qrSessionId}`);
          const images = Array.isArray(response.data?.images) ? response.data.images : [];

          if (images.length > 0) {
            /*
              Mantém o mesmo QR Code e a mesma sessão ativos.
              Cada lote recebido é processado e o polling continua rodando,
              permitindo tirar e enviar várias fotos pelo celular.
              A sessão só termina quando o usuário clicar no X/Fechar do modal.
            */
            await processarImagensDaCamera(images);
          }
        } catch (error) {
          /*
            O back-end atual responde 404 quando ainda não existe foto pendente.
            Isso é normal durante o polling e não deve poluir o console.
          */
          if (error?.response?.status !== 404) {
            console.error('Erro ao sincronizar câmera:', error);
          }
        } finally {
          consultando = false;
        }
      }, 3000);
    }

    return () => {
      cancelado = true;
      clearInterval(interval);
    };
  }, [showQRModal, qrSessionId, uploadAnexoParaServidor]);

  const fetchEmpresas = useCallback(async () => {
    setLoadingEmpresas(true);
    try {
      const response = await api.get('/empresas', {
        params: montarParamsEmpresa(empresaIdAtual)
      });

      setEmpresas(resolverArrayApi(response.data, 'empresas'));
    } catch (error) {
      console.error('Erro ao buscar empresas:', error);
    } finally {
      setLoadingEmpresas(false);
    }
  }, [empresaIdAtual]);

  const fetchUsuarios = useCallback(async () => {
    setLoadingUsuarios(true);
    try {
      const response = await api.get('/users', {
        params: montarParamsEmpresa(empresaIdAtual)
      });

      setUsuarios(resolverArrayApi(response.data, 'users'));
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
    } finally {
      setLoadingUsuarios(false);
    }
  }, [empresaIdAtual]);

  useEffect(() => {
    fetchEmpresas();
    fetchUsuarios();
  }, [fetchEmpresas, fetchUsuarios]);

  const limparErro = (key) => {
    if (!errors[key]) return;
    setErrors((prev) => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
  };

  const update = (path, value) => {
    limparErro(path);
    setForm((prev) => {
      const copy = JSON.parse(JSON.stringify(prev));
      const keys = path.split('.');
      let ref = copy;
      for (let i = 0; i < keys.length - 1; i++) ref = ref[keys[i]];
      ref[keys[keys.length - 1]] = value;
      return copy;
    });
  };


  const selecionarEmpresa = (valor) => {
    limparErro('loja');

    const empresa = empresas.find((emp) => {
      return (
        mesmoId(emp?._id, valor) ||
        mesmoId(emp?.id, valor) ||
        String(emp?.codigoLoja || '').trim() === String(valor || '').trim()
      );
    });

    setForm((prev) => ({
      ...prev,
      empresaId: empresa?._id || empresa?.id || '',
      loja: empresa?.codigoLoja || valor,
      vendedorId: '',
      vendedor: ''
    }));
  };

  const selecionarVendedor = (valor) => {
    limparErro('vendedor');

    const vendedor = vendedoresDisponiveis.find((user) => {
      return (
        mesmoId(user?._id, valor) ||
        String(user?.nomeCompleto || '').trim() === String(valor || '').trim()
      );
    });

    setForm((prev) => ({
      ...prev,
      vendedorId: vendedor?._id || '',
      vendedor: vendedor?.nomeCompleto || vendedor?.nome || valor
    }));
  };

  const updateItem = (index, path, value) => {
    const errorKey =
      path === 'paciente'
        ? `item_${index}_paciente`
        : path === 'lente'
          ? `item_${index}_lente`
          : path === 'armacao'
            ? `item_${index}_armacao`
            : null;

    if (errorKey) limparErro(errorKey);

    setForm((prev) => {
      const next = { ...prev };
      const itens = [...next.itens];
      const item = JSON.parse(JSON.stringify(itens[index]));
      const keys = path.split('.');
      let ref = item;
      for (let i = 0; i < keys.length - 1; i++) ref = ref[keys[i]];
      ref[keys[keys.length - 1]] = value;
      itens[index] = item;
      next.itens = itens;
      return next;
    });
  };

  const addNovoOculos = () => {
    setForm((prev) => ({
      ...prev,
      itens: [...prev.itens, JSON.parse(JSON.stringify(itemPadrao))]
    }));
  };

  const removerOculos = (index) => {
    if (!window.confirm('Deseja remover este óculos?')) return;

    revogarArmacaoBlob(index);

    setForm((prev) => {
      const itens = prev.itens.filter((_, i) => i !== index);
      const totalArmacoes = itens.reduce((acc, itemForm) => {
        return acc + Number(itemForm.armacaoPreco || 0);
      }, 0);

      return {
        ...prev,
        itens,
        valorTotal: totalArmacoes > 0 ? formatMoneyInput(totalArmacoes) : prev.valorTotal
      };
    });
  };

  const copiarDadosDoPrimeiroOculos = (index) => {
    setForm((prev) => {
      const itens = [...prev.itens];
      itens[index].paciente = prev.itens[0].paciente;
      itens[index].receita = JSON.parse(JSON.stringify(prev.itens[0].receita));
      return { ...prev, itens };
    });
  };

  const anexarImagemArmacaoNoPedido = useCallback(async ({ armacao, itemIndex, file, objectUrl }) => {
    if (!armacao?._id || !file || !Number.isInteger(itemIndex)) return;

    /*
      Card fixo dos anexos:
      0 = Cliente com óculos
      1 = Cliente sem óculos
      2 = Somente o óculos / armação

      A imagem da armação selecionada sempre vai para o card 3.
    */
    const anexoIndex = ARMACAO_ANEXO_OCULOS_INDEX;

    if (objectUrl) {
      const previewAnterior = previewUrlsRef.current[anexoIndex];

      if (previewAnterior && previewAnterior.startsWith('blob:') && previewAnterior !== objectUrl) {
        URL.revokeObjectURL(previewAnterior);
      }

      previewUrlsRef.current[anexoIndex] = objectUrl;
      setLocalPreviewMap((prev) => ({
        ...prev,
        [anexoIndex]: objectUrl
      }));
    } else {
      definirPreviewLocal(anexoIndex, file);
    }

    const imageUrl = await uploadAnexoParaServidor(file, {
      index: anexoIndex,
      origem: 'armacao-estoque'
    });

    if (!imageUrl) {
      limparPreviewLocal(anexoIndex);
      return;
    }

    setForm((prev) => {
      const next = { ...prev };
      const itens = [...next.itens];
      const itemSelecionado = JSON.parse(JSON.stringify(itens[itemIndex] || {}));
      const anexos = [...(next.anexos || [])];

      while (anexos.length <= anexoIndex) {
        anexos.push('');
      }

      anexos[anexoIndex] = imageUrl;

      itemSelecionado.armacaoAnexoUrl = imageUrl;
      itemSelecionado.armacaoAnexoIndex = anexoIndex;
      itens[itemIndex] = itemSelecionado;

      return {
        ...next,
        itens,
        anexos
      };
    });
  }, [
    definirPreviewLocal,
    limparPreviewLocal,
    uploadAnexoParaServidor
  ]);

  const handleArmacaoSearch = async (text, index) => {
    limparErro(`item_${index}_armacao`);

    setForm((prev) => {
      const next = { ...prev };
      const itens = [...next.itens];
      const itemAtual = JSON.parse(JSON.stringify(itens[index]));

      if (itemAtual.armacaoId || itemAtual.armacaoImagemBlob) {
        revogarArmacaoBlob(index);
      }

      const indiceAnexoAnterior = Number(itemAtual.armacaoAnexoIndex);
      const tinhaAnexoDaArmacao =
        Number.isInteger(indiceAnexoAnterior) &&
        indiceAnexoAnterior >= 0 &&
        itemAtual.armacaoAnexoUrl;

      itemAtual.armacao = text;
      itemAtual.armacaoId = '';
      itemAtual.armacaoImagemUrl = '';
      itemAtual.armacaoImagemBlob = '';
      itemAtual.armacaoPreco = 0;
      itemAtual.armacaoAnexoUrl = '';
      itemAtual.armacaoAnexoIndex = null;

      itens[index] = itemAtual;
      next.itens = itens;

      if (tinhaAnexoDaArmacao) {
        const anexos = [...(next.anexos || [])];

        if (anexos[indiceAnexoAnterior] === itemAtual.armacaoAnexoUrl) {
          anexos[indiceAnexoAnterior] = '';
        }

        next.anexos = anexos;

        limparPreviewLocal(indiceAnexoAnterior);
      }

      return next;
    });

    if (text.length < 2) {
      setArmacaoSuggestions([]);
      setShowSuggestionsIndex(null);
      return;
    }

    setIsSearchingStock(true);
    setShowSuggestionsIndex(index);

    try {
      const response = await api.get(`/api/armacoes?ref=${encodeURIComponent(text)}`);
      const lista = resolverArrayApi(response.data, 'armacoes');

      setArmacaoSuggestions(lista.filter((item) => Number(item.qtd || 0) > 0));
    } catch {
      setArmacaoSuggestions([]);
    } finally {
      setIsSearchingStock(false);
    }
  };

  const selectArmacao = async (item, index) => {
    const descricaoArmacao = `${item.marca || ''} ${item.ref || ''} (${item.cor || ''})`.trim();
    const precoArmacao = Number(item.preco || 0);

    revogarArmacaoBlob(index);

    let imagemBlob = '';
    let imagemFile = null;

    if (item._id && item.imagemUrl) {
      const imagemArmacao = await carregarImagemArmacaoArquivo(item);
      imagemBlob = imagemArmacao.objectUrl || '';
      imagemFile = imagemArmacao.file || null;

      if (imagemBlob) {
        armacaoBlobUrlsRef.current[index] = imagemBlob;
      }
    }

    setForm((prev) => {
      const next = { ...prev };
      const itens = [...next.itens];
      const itemAtual = JSON.parse(JSON.stringify(itens[index]));

      itemAtual.armacao = descricaoArmacao;
      itemAtual.armacaoId = item._id || '';
      itemAtual.armacaoImagemUrl = item.imagemUrl || '';
      itemAtual.armacaoImagemBlob = imagemBlob;
      itemAtual.armacaoPreco = precoArmacao;

      itens[index] = itemAtual;

      const totalArmacoes = itens.reduce((acc, itemForm) => {
        return acc + Number(itemForm.armacaoPreco || 0);
      }, 0);

      return {
        ...next,
        itens,
        valorTotal: totalArmacoes > 0 ? formatMoneyInput(totalArmacoes) : next.valorTotal
      };
    });

    setShowSuggestionsIndex(null);
    setArmacaoSuggestions([]);

    if (imagemFile) {
      await anexarImagemArmacaoNoPedido({
        armacao: item,
        itemIndex: index,
        file: imagemFile,
        objectUrl: imagemBlob
      });
    }
  };

    const handleLenteSearch = async (text, index) => {
    updateItem(index, 'lente', text);
    if (text.length < 2) {
      setLenteSuggestions([]);
      setShowLenteSuggestionsIndex(null);
      return;
    }
    setIsSearchingLente(true);
    setShowLenteSuggestionsIndex(index);
    try {
      const response = await api.get('/produtos');
      setLenteSuggestions(
        response.data.filter(
          (prod) =>
            prod.categoria === 'Lente' &&
            prod.nome.toLowerCase().includes(text.toLowerCase())
        )
      );
    } catch {
      setLenteSuggestions([]);
    } finally {
      setIsSearchingLente(false);
    }
  };

  const selectLente = (item, index) => {
    updateItem(index, 'lente', item.nome);
    setShowLenteSuggestionsIndex(null);
  };

  const checkCEP = async (e) => {
    const cep = e.target.value.replace(/\D/g, '');
    if (cep.length !== 8) return;
    setLoadingCep(true);
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await res.json();
      if (!data.erro) {
        setForm((prev) => ({
          ...prev,
          endereco: data.logradouro,
          bairro: data.bairro,
          cidade: data.localidade,
          uf: data.uf
        }));
      }
    } catch {
    } finally {
      setLoadingCep(false);
    }
  };

  const addPayment = () => {
    const val = parseMoney(novoPagamento.valor);
    if (val <= 0) return alert('Digite um valor válido.');
    setForm((prev) => ({
      ...prev,
      pagamentos: [
        ...prev.pagamentos,
        {
          id: Date.now(),
          metodo: novoPagamento.metodo,
          valor: val,
          parcelas: novoPagamento.metodo === 'Crédito' ? Number(novoPagamento.parcelas) : 1
        }
      ]
    }));
    setNovoPagamento({ metodo: 'Dinheiro', valor: '', parcelas: 1 });
  };

  const removePayment = (id) => {
    setForm((prev) => ({
      ...prev,
      pagamentos: prev.pagamentos.filter((p) => p.id !== id)
    }));
  };

  const openMobileCamera = () => {
    setQrSessionId(`os_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`);
    setShowQRModal(true);
  };

  const closeMobileCamera = () => {
    setQrSessionId(null);
    setShowQRModal(false);
  };

  const handleFileChange = async (index, file) => {
    if (!file) return;

    // Mostra o preview imediatamente, antes mesmo do upload terminar.
    definirPreviewLocal(index, file);

    const imageUrl = await uploadAnexoParaServidor(file, {
      index,
      origem: 'input-arquivo'
    });

    if (!imageUrl) {
      limparPreviewLocal(index);
    }
  };

  const addImageSlot = () => {
    setForm((prev) => ({ ...prev, anexos: [...prev.anexos, ''] }));
  };

  const removeImage = (index) => {
    limparPreviewLocal(index);

    const newAnexos = [...form.anexos];
    newAnexos[index] = '';

    setForm((prev) => ({ ...prev, anexos: newAnexos }));
  };

  const handleEnterNavigation = (e, currentIndex) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const nextInput = document.querySelector(`input[data-idx="${currentIndex + 1}"]`);
      if (nextInput) {
        nextInput.focus();
        nextInput.select();
      }
    }
  };

  const validateForm = () => {
    const next = {};
    if (!String(form.empresaId || form.loja || '').trim()) next.loja = true;
    if (!String(form.vendedorId || form.vendedor || '').trim()) next.vendedor = true;
    if (!form.cliente.trim()) next.cliente = true;
    if (!form.whatsapp.trim()) next.whatsapp = true;
    if (!form.dataCompra) next.dataCompra = true;
    if (!form.dataEntrega) next.dataEntrega = true;

    form.itens.forEach((item, index) => {
      if (!item.paciente.trim()) next[`item_${index}_paciente`] = true;
      if (!item.lente.trim()) next[`item_${index}_lente`] = true;
      if (!item.armacao.trim()) next[`item_${index}_armacao`] = true;
    });

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const valorTotalNum = parseMoney(form.valorTotal);
  const totalPago = form.pagamentos.reduce((acc, p) => acc + p.valor, 0);
  const restante = valorTotalNum - totalPago;
  const mobileCameraUrl = `${window.location.origin}/camera/${qrSessionId}`;

  const handleSubmit = async () => {
    if (loading) return;
    if (compressing) return alert('Aguarde o processamento das imagens...');

    if (!validateForm()) {
      document.querySelector('.scroll-area')?.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    let progressTimer = null;

    setLoading(true);
    setSaveProgress(3);
    setSaveMessage('Preparando ordem de serviço...');
    setSaveDetail('Conferindo dados da venda e anexos.');

    try {
      progressTimer = setInterval(() => {
        setSaveProgress((prev) => {
          if (prev >= 92) return prev;
          const incremento = Math.max(1, Math.round((92 - prev) * 0.08));
          return Math.min(92, prev + incremento);
        });
      }, 450);

      const anexosFinais = form.anexos.filter(Boolean);

      const payload = {
        ...form,
        empresaId: form.empresaId || empresaSelecionada?._id || empresaIdAtual || null,
        loja: form.loja || empresaSelecionada?.codigoLoja || '',
        vendedorId: form.vendedorId || null,
        vendedor: form.vendedor || '',
        itens: form.itens.map((item) => ({
          paciente: { nome: item.paciente },
          receita: item.receita,
          produto: {
            lente: item.lente,
            armacao: item.armacao,
            armacaoId: item.armacaoId || null,
            armacaoPreco: Number(item.armacaoPreco || 0),
            armacaoImagemUrl: item.armacaoImagemUrl || '',
            numeroCV: item.cv,
            medidasArmacao: item.medidasArmacao,
            origemArmacao: item.origemArmacao,
            envioArmacao: item.envioArmacao,
            formatoArmacao: item.formatoArmacao
          }
        })),
        valorTotal: valorTotalNum,
        registroTexto: form.novoTextoRegistro,
        anexos: anexosFinais,
        cliente: {
          nome: form.cliente,
          cpf: form.cpf,
          dataNascimento: form.dataNascimento
        },
        endereco: {
          cep: form.cep,
          logradouro: form.endereco,
          numero: form.numero,
          complemento: form.complemento,
          bairro: form.bairro,
          cidade: form.cidade,
          uf: form.uf
        }
      };

      setSaveMessage('Enviando pedido para o servidor...');
      setSaveDetail('Salvando dados da OS no banco.');
      setSaveProgress((prev) => Math.max(prev, 18));

      const response = await api.post('/ordens-servico', payload, {
        onUploadProgress: (event) => {
          if (!event.total) return;

          const percent = Math.round((event.loaded * 100) / event.total);
          setSaveProgress(Math.min(92, Math.max(18, percent)));
        }
      });

      if (progressTimer) {
        clearInterval(progressTimer);
        progressTimer = null;
      }

      setSaveMessage('Pedido salvo com sucesso.');
      setSaveDetail('Finalizando e atualizando a tela.');
      setSaveProgress(100);

      await delay(350);

      onSuccess?.(response.data);
    } catch (err) {
      if (progressTimer) {
        clearInterval(progressTimer);
        progressTimer = null;
      }

      setSaveProgress(0);
      setSaveMessage('');
      setSaveDetail('');

      alert(err.response?.data?.error || 'Erro ao salvar O.S.');
    } finally {
      if (progressTimer) clearInterval(progressTimer);

      setLoading(false);

      setTimeout(() => {
        setSaveProgress(0);
        setSaveMessage('');
        setSaveDetail('');
      }, 400);
    }
  };

  const formatos = [
    { id: 'Redondo', label: 'Redondo', Icon: Icons.ShapeRound },
    { id: 'Quadrado', label: 'Quadrado', Icon: Icons.ShapeSquare },
    { id: 'Retangular', label: 'Retangular', Icon: Icons.ShapeRect },
    { id: 'Oval', label: 'Oval', Icon: Icons.ShapeOval },
    { id: 'Aviador', label: 'Aviador', Icon: Icons.ShapeAviator },
    { id: 'Gatinho', label: 'Gatinho', Icon: Icons.ShapeCat }
  ];

  return (
    <div
      style={styles.shell}
      className="os-form-shell"
      onClick={() => {
        setShowSuggestionsIndex(null);
        setShowLenteSuggestionsIndex(null);
      }}
    >
      <style>{`
        :root {
          --lumix-bg: #f8fafd;
          --lumix-card: #ffffff;
          --lumix-text: #202124;
          --lumix-muted: #5f6368;
          --lumix-soft: #80868b;
          --lumix-border: #dadce0;
          --lumix-border-soft: #edf0f3;
          --lumix-blue: #1a73e8;
          --lumix-green: #188038;
          --lumix-red: #d93025;
          --lumix-amber: #f9ab00;
        }

        .os-field {
          transition: border-color 0.14s ease, background 0.14s ease, box-shadow 0.14s ease;
        }

        .os-field:focus,
        .os-field select:focus,
        .os-field input:focus,
        .os-field textarea:focus {
          outline: none;
          border-color: var(--lumix-blue) !important;
          background: #ffffff !important;
          box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.10) !important;
        }

        .os-scroll::-webkit-scrollbar { width: 7px; height: 7px; }
        .os-scroll::-webkit-scrollbar-track { background: transparent; }
        .os-scroll::-webkit-scrollbar-thumb { background: rgba(128, 134, 139, 0.35); border-radius: 999px; }

        @media (max-width: 920px) {
          .os-grid-2 { grid-template-columns: 1fr !important; }
          .os-grid-4 { grid-template-columns: 1fr 1fr !important; }
          .os-anexos { grid-template-columns: repeat(3, 1fr) !important; }
          .os-loja-grid { grid-template-columns: 1fr !important; }
          .os-actions { flex-direction: column !important; }
          .os-actions button { width: 100%; }
          .os-finance { flex-direction: column !important; align-items: stretch !important; }
          .os-finance button { width: 100%; height: 40px !important; }
          .os-footer { flex-direction: column-reverse !important; }
          .os-footer button { width: 100%; min-height: 42px; }
          .os-header { flex-direction: column !important; align-items: stretch !important; }
          .os-header-main { flex-direction: column !important; align-items: flex-start !important; }
          .os-header-right { width: 100%; display: grid !important; grid-template-columns: 1fr 1fr; gap: 8px !important; }
        }

        @media (max-width: 640px) {
          .os-header-right { grid-template-columns: 1fr !important; }
          .os-anexos { grid-template-columns: repeat(2, 1fr) !important; }
          .os-shapes { grid-template-columns: repeat(2, 1fr) !important; }
        }

        @media (max-width: 420px) {
          .os-anexos { grid-template-columns: 1fr 1fr !important; }
          .os-shapes { grid-template-columns: 1fr 1fr !important; }
        }


        .os-form-shell {
          --screen-bg: #ffffff;
          --screen-line: #e8eaed;
          --screen-soft: #f8fafd;
          --screen-text: #202124;
          --screen-muted: #5f6368;
          --screen-blue: #1a73e8;
        }

        .os-live-summary {
          width: 100%;
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 0;
          border-top: 1px solid var(--screen-line);
          border-bottom: 1px solid var(--screen-line);
          background: #ffffff;
        }

        .os-live-summary > div {
          min-width: 0;
          padding: 12px 16px;
          border-right: 1px solid var(--screen-line);
        }

        .os-live-summary > div:last-child {
          border-right: 0;
        }

        .os-live-summary span {
          display: block;
          color: var(--screen-muted);
          font-size: 10.5px;
          font-weight: 800;
          letter-spacing: .055em;
          text-transform: uppercase;
        }

        .os-live-summary strong {
          display: block;
          margin-top: 4px;
          color: var(--screen-text);
          font-size: 14px;
          font-weight: 850;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .os-live-summary strong.ok { color: #188038; }
        .os-live-summary strong.pending { color: #d93025; }

        .os-section-row {
          box-shadow: none !important;
          transition: background .16s ease;
        }

        .os-section-row:hover {
          background: #fbfcfe !important;
        }

        .os-item-panel {
          box-shadow: none !important;
        }

        .os-receita-card {
          scrollbar-width: thin;
        }

        .os-receita-card::-webkit-scrollbar {
          height: 5px;
        }

        .os-receita-card::-webkit-scrollbar-thumb {
          background: rgba(95,99,104,.25);
          border-radius: 999px;
        }

        @media (max-width: 920px) {
          .os-form-shell {
            border: 0 !important;
            border-radius: 0 !important;
            min-height: 100svh !important;
            background: #ffffff !important;
          }

          .os-header {
            position: sticky !important;
            top: 0;
            z-index: 25;
            padding: 16px 14px 12px !important;
            background: rgba(255,255,255,.96) !important;
            backdrop-filter: blur(16px);
            border-bottom: 1px solid var(--screen-line) !important;
          }

          .os-header-main {
            gap: 12px !important;
          }

          .os-header h2 {
            font-size: 26px !important;
            font-weight: 850 !important;
            letter-spacing: -0.045em !important;
          }

          .os-header-right {
            width: 100%;
            display: grid !important;
            grid-template-columns: 1fr 1fr !important;
            gap: 8px !important;
          }

          .os-live-summary {
            position: sticky;
            top: 0;
            z-index: 10;
            grid-template-columns: repeat(4, minmax(132px, 1fr));
            overflow-x: auto;
            overscroll-behavior-x: contain;
          }

          .os-live-summary > div {
            padding: 11px 13px;
          }

          .scroll-area {
            padding: 0 14px 96px !important;
            background: #ffffff !important;
          }

          .os-section-row {
            padding: 22px 0 !important;
            border: 0 !important;
            border-bottom: 1px solid var(--screen-line) !important;
            border-radius: 0 !important;
            background: transparent !important;
          }

          .os-section-row:hover {
            background: transparent !important;
          }

          .os-grid-2 {
            grid-template-columns: 1fr !important;
            gap: 12px !important;
          }

          .os-grid-4 {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 10px !important;
          }

          .os-field {
            min-height: 48px !important;
            border-radius: 14px !important;
            font-size: 15px !important;
            padding-left: 13px !important;
            padding-right: 13px !important;
          }

          label {
            font-size: 12px !important;
          }

          .os-item-panel {
            margin-top: 14px !important;
            padding: 14px 0 0 !important;
            border: 0 !important;
            border-top: 1px solid var(--screen-line) !important;
            border-radius: 0 !important;
            background: transparent !important;
          }

          .os-actions {
            flex-direction: row !important;
            flex-wrap: wrap !important;
          }

          .os-actions button {
            width: auto !important;
            min-height: 36px !important;
          }

          .os-receita-card {
            overflow-x: auto !important;
            border-radius: 16px !important;
          }

          .os-receita-card > div {
            min-width: 520px !important;
          }

          .os-photo-guide {
            display: none !important;
          }

          .os-anexos {
            grid-template-columns: 1fr !important;
            gap: 10px !important;
          }

          .os-shapes {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 10px !important;
          }

          .os-finance {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 10px !important;
          }

          .os-finance button {
            width: 100%;
            height: 46px !important;
          }

          .os-footer {
            position: sticky !important;
            bottom: 0;
            z-index: 30;
            padding: 10px 14px calc(10px + env(safe-area-inset-bottom)) !important;
            background: rgba(255,255,255,.96) !important;
            backdrop-filter: blur(16px);
            border-top: 1px solid var(--screen-line) !important;
            display: grid !important;
            grid-template-columns: 1fr 1.4fr !important;
            gap: 9px !important;
          }

          .os-footer button {
            width: 100% !important;
            min-height: 48px !important;
            border-radius: 14px !important;
            font-size: 14px !important;
            font-weight: 850 !important;
          }
        }

        @media (max-width: 520px) {
          .os-header-right {
            grid-template-columns: 1fr !important;
          }

          .os-live-summary {
            grid-template-columns: repeat(4, minmax(120px, 1fr));
          }

          .os-section-row {
            padding: 20px 0 !important;
          }

          .os-anexos {
            grid-template-columns: 1fr !important;
          }

          .os-shapes {
            grid-template-columns: 1fr 1fr !important;
          }
        }



        /* V2: formulário grudado na tela, sem linguagem de cards */
        .os-form-shell {
          background: #fff !important;
          border: 0 !important;
          border-radius: 0 !important;
          box-shadow: none !important;
        }

        .os-section-row {
          background: transparent !important;
          border: 0 !important;
          border-bottom: 1px solid #e8eaed !important;
          border-radius: 0 !important;
          box-shadow: none !important;
        }

        .os-section-row:hover {
          background: transparent !important;
        }

        .os-item-panel {
          background: transparent !important;
          border: 0 !important;
          border-top: 1px solid #e8eaed !important;
          border-radius: 0 !important;
          box-shadow: none !important;
        }

        .os-receita-card {
          border-radius: 0 !important;
          border-left: 0 !important;
          border-right: 0 !important;
          background: #fff !important;
        }

        .os-live-summary {
          border-radius: 0 !important;
          box-shadow: none !important;
        }

        @media (max-width: 920px) {
          .os-header {
            padding: 10px 12px 8px !important;
          }

          .os-header h2 {
            font-size: 21px !important;
            line-height: 1.05 !important;
          }

          .os-header-main {
            gap: 8px !important;
          }

          .os-header-right {
            gap: 6px !important;
          }

          .os-live-summary {
            top: 0;
            grid-template-columns: repeat(4, minmax(104px, 1fr)) !important;
            border-top: 0 !important;
          }

          .os-live-summary > div {
            padding: 8px 10px !important;
          }

          .os-live-summary span {
            font-size: 9.5px !important;
          }

          .os-live-summary strong {
            font-size: 12.5px !important;
            margin-top: 2px !important;
          }

          .scroll-area {
            padding: 0 12px 76px !important;
          }

          .os-section-row {
            padding: 14px 0 !important;
          }

          .os-section-row [style*="margin-bottom: 16px"] {
            margin-bottom: 10px !important;
          }

          .os-grid-2 {
            gap: 8px !important;
          }

          .os-grid-4 {
            gap: 7px !important;
          }

          .os-field {
            min-height: 38px !important;
            height: 38px !important;
            border-radius: 8px !important;
            font-size: 13px !important;
            padding-left: 10px !important;
            padding-right: 10px !important;
          }

          input.os-field,
          select.os-field {
            min-height: 38px !important;
            height: 38px !important;
          }

          textarea.os-field,
          textarea {
            min-height: 76px !important;
            border-radius: 8px !important;
            font-size: 13px !important;
            padding: 10px !important;
          }

          label {
            font-size: 10.5px !important;
            margin-bottom: 3px !important;
          }

          .os-item-panel {
            margin-top: 10px !important;
            padding-top: 10px !important;
          }

          .os-receita-card {
            margin-left: -12px !important;
            margin-right: -12px !important;
            border-radius: 0 !important;
          }

          .os-receita-card > div {
            min-width: 500px !important;
          }

          .os-anexos {
            gap: 7px !important;
          }

          .os-shapes {
            gap: 7px !important;
          }

          .os-actions {
            gap: 6px !important;
          }

          .os-actions button {
            min-height: 32px !important;
            height: 32px !important;
            border-radius: 8px !important;
            font-size: 12px !important;
            padding: 0 9px !important;
          }

          .os-finance {
            gap: 7px !important;
          }

          .os-finance button {
            height: 38px !important;
            border-radius: 8px !important;
            font-size: 13px !important;
          }

          .os-footer {
            padding: 7px 10px calc(7px + env(safe-area-inset-bottom)) !important;
            grid-template-columns: .85fr 1.15fr !important;
            gap: 7px !important;
          }

          .os-footer button {
            min-height: 40px !important;
            height: 40px !important;
            border-radius: 8px !important;
            font-size: 13px !important;
          }
        }

        @media (max-width: 520px) {
          .scroll-area {
            padding-left: 10px !important;
            padding-right: 10px !important;
          }

          .os-section-row {
            padding: 12px 0 !important;
          }

          .os-live-summary {
            grid-template-columns: repeat(4, minmax(98px, 1fr)) !important;
          }

          .os-grid-4 {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          }

          .os-field {
            min-height: 36px !important;
            height: 36px !important;
            font-size: 12.5px !important;
          }

          input.os-field,
          select.os-field {
            min-height: 36px !important;
            height: 36px !important;
          }

          .os-footer button {
            height: 38px !important;
            min-height: 38px !important;
          }
        }


        @keyframes spin { 100% { transform: rotate(360deg); } }
        @keyframes progressShimmer {
          from { background-position: 0 0; }
          to { background-position: 36px 0; }
        }
        @keyframes osFadeUp {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes photoIconFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-3px); }
        }

        @keyframes photoCardIn {
          from { opacity: 0; transform: translateY(5px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {showQRModal && (
        <div style={styles.overlay}>
          <div style={styles.modalCard}>
            <h3 style={styles.modalTitle}>Câmera do celular</h3>
            <p style={styles.modalText}>Escaneie uma vez e envie quantas fotos precisar. A sessão permanece ativa até você clicar em Fechar.</p>
            <div style={styles.qrBox}>
              <QRCodeSVG value={mobileCameraUrl} size={130} />
            </div>
            <button type="button" onClick={closeMobileCamera} style={styles.btnGhost}>Fechar</button>
          </div>
        </div>
      )}

      {compressing && (
        <div style={styles.overlay}>
          <div style={styles.modalCard}>
            <div style={styles.spinner}></div>
            <h3 style={styles.modalTitle}>Processando imagem</h3>
            <p style={styles.modalText}>{uploadMessage}</p>
            <div style={styles.progressBg}>
              <div style={{ ...styles.progressFill, width: `${uploadProgress}%` }}></div>
            </div>
            <div style={styles.progressPercent}>{Math.round(uploadProgress)}%</div>
          </div>
        </div>
      )}

      {loading && (
        <div style={styles.overlay}>
          <div style={styles.modalCard}>
            <div style={styles.spinner}></div>
            <h3 style={styles.modalTitle}>Salvando pedido</h3>
            <p style={styles.modalText}>{saveMessage || 'Enviando dados para o servidor...'}</p>
            {saveDetail ? <p style={styles.saveDetail}>{saveDetail}</p> : null}
            <div style={styles.progressBg}>
              <div style={{ ...styles.progressFill, width: `${saveProgress}%` }}></div>
            </div>
            <div style={styles.progressPercent}>{Math.round(saveProgress)}%</div>
          </div>
        </div>
      )}

      <div style={styles.topBar} className="os-header">
        <div style={styles.topBarMain} className="os-header-main">
          <div>
            <div style={styles.kicker}>ORDEM DE SERVIÇO</div>
            <h2 style={styles.title}>Nova venda</h2>
            <div style={styles.headerSubtitle}>Escolha a unidade no topo e siga com os dados da venda.</div>
          </div>

          <div style={styles.topBarRight} className="os-header-right">
            <div style={styles.statusCard}>
              <span style={styles.statusLabel}>Boas-vindas</span>
              <button
                type="button"
                onClick={() => update('statusmsg', form.statusmsg === 'Pendente' ? 'Enviada' : 'Pendente')}
                style={{
                  ...styles.toggleBtn,
                  ...(form.statusmsg === 'Enviada' ? styles.toggleBtnActive : {})
                }}
              >
                <Icons.Message />
                {form.statusmsg === 'Enviada' ? 'Enviar boas-vindas' : 'Não enviar boas-vindas'}
              </button>
            </div>

            <div style={styles.statusCard}>
              <span style={styles.statusLabel}>Status</span>
              <select
                style={styles.topSelect}
                value={form.status}
                onChange={(e) => update('status', e.target.value)}
              >
                {statusOptions.map((opt) => <option key={opt}>{opt}</option>)}
              </select>
            </div>
          </div>
        </div>

        <div style={{ ...styles.lojaTopPanel, ...(errors.loja ? styles.lojaTopPanelError : {}) }}>
          <div style={styles.lojaTopHeader}>
            <div>
              <div style={styles.lojaTopKicker}>Unidade da venda</div>
              <div style={styles.lojaTopTitle}>
                <Icons.Building />
                <span>{lojaTopoCodigo}</span>
              </div>
              <div style={styles.lojaTopSubtitle}>{lojaTopoNome}</div>
            </div>

            <div style={styles.lojaTopMeta}>
              <span>{vendedoresDisponiveis.length}</span>
              vendedor(es)
            </div>
          </div>

          <div style={styles.lojaTopGrid} className="os-loja-grid">
            <Field label="Loja" required error={errors.loja}>
              <select
                className="os-field"
                style={{ ...styles.input, ...(errors.loja ? styles.inputError : {}) }}
                value={form.empresaId || form.loja}
                onChange={(e) => selecionarEmpresa(e.target.value)}
                disabled={loadingEmpresas}
              >
                <option value="">{loadingEmpresas ? 'Carregando empresas...' : 'Selecione a loja'}</option>
                {empresasAtivas.map((emp) => {
                  const codigo = emp.codigoLoja || emp.loja || emp._id || emp.id;
                  const nome = emp.unidade || emp.nome || '';
                  return (
                    <option key={emp._id || emp.codigoLoja} value={emp._id || emp.id || emp.codigoLoja}>
                      {codigo}{nome ? ` · ${nome}` : ''}
                    </option>
                  );
                })}
              </select>
            </Field>

            <Field label="Vendedor" required error={errors.vendedor}>
              <select
                className="os-field"
                style={{ ...styles.input, ...(errors.vendedor ? styles.inputError : {}) }}
                value={form.vendedorId || form.vendedor}
                onChange={(e) => selecionarVendedor(e.target.value)}
                disabled={loadingUsuarios || (!form.empresaId && !form.loja)}
              >
                <option value="">{loadingUsuarios ? 'Carregando usuários...' : 'Selecione o vendedor'}</option>
                {vendedoresDisponiveis.map((user) => (
                  <option key={user._id || user.nomeCompleto} value={user._id || user.nomeCompleto}>
                    {user.nomeCompleto || user.nome}
                  </option>
                ))}
              </select>
            </Field>

            <div style={styles.lojaMiniInfo}>
              <div style={styles.lojaMiniItem}>
                <Icons.Phone />
                <span>{empresaSelecionada?.whatsapp || empresaSelecionada?.telefone || 'Telefone não informado'}</span>
              </div>
              <div style={styles.lojaMiniItem}>
                <Icons.MapPin />
                <span>{empresaSelecionada?.endereco || 'Endereço não informado'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div className="os-live-summary">
          <div>
            <span>Cliente</span>
            <strong>{form.cliente || 'Não informado'}</strong>
          </div>
          <div>
            <span>Entrega</span>
            <strong>{form.dataEntrega ? form.dataEntrega.split('-').reverse().join('/') : 'Sem data'}</strong>
          </div>
          <div>
            <span>Total</span>
            <strong>{formatCurrency(valorTotalNum)}</strong>
          </div>
          <div>
            <span>Saldo</span>
            <strong className={restante > 0.01 ? 'pending' : 'ok'}>{restante <= 0.01 ? 'Quitado' : formatCurrency(restante)}</strong>
          </div>
        </div>

      <div style={styles.body} className="scroll-area os-scroll">
        {Object.keys(errors).length > 0 && (
          <div style={styles.errorBanner}>
            <Icons.Alert /> Preencha os campos obrigatórios.
          </div>
        )}

        <div style={styles.mainStack}>
          {/* SESSÃO COMPRADOR E DADOS DA EMPRESA */}
          <div style={styles.card} className="os-section-row">
            <SectionTitle icon={<Icons.User />} title="Comprador" subtitle="Dados do cliente" />
            <div style={styles.grid2} className="os-grid-2">
              <Field label="Nome do comprador" required error={errors.cliente} span2>
                <input className="os-field" style={{ ...styles.input, ...(errors.cliente ? styles.inputError : {}) }} value={form.cliente} onChange={(e) => update('cliente', e.target.value)} placeholder="Nome completo" />
              </Field>

              <Field label="CPF"><input className="os-field" style={styles.input} value={form.cpf} onChange={(e) => update('cpf', masks.cpf(e.target.value))} placeholder="000.000.000-00" maxLength={14} /></Field>
              <Field label="Nascimento"><input className="os-field" type="date" style={styles.input} value={form.dataNascimento} onChange={(e) => update('dataNascimento', e.target.value)} /></Field>
              <Field label="WhatsApp" required error={errors.whatsapp}><input className="os-field" style={{ ...styles.input, ...(errors.whatsapp ? styles.inputError : {}) }} value={form.whatsapp} onChange={(e) => update('whatsapp', masks.phone(e.target.value))} placeholder="(00) 00000-0000" /></Field>
              
              <div style={styles.grid2}>
                <Field label="Data da venda" required error={errors.dataCompra}><input className="os-field" type="date" style={{ ...styles.input, ...(errors.dataCompra ? styles.inputError : {}) }} value={form.dataCompra} onChange={(e) => update('dataCompra', e.target.value)} /></Field>
                <Field label="Entrega" required error={errors.dataEntrega}><input className="os-field" type="date" style={{ ...styles.input, ...(errors.dataEntrega ? styles.inputError : {}) }} value={form.dataEntrega} onChange={(e) => update('dataEntrega', e.target.value)} /></Field>
              </div>
            </div>
          </div>

          {/* SESSÃO ENDEREÇO */}
          <div style={styles.card} className="os-section-row">
            <SectionTitle icon={<Icons.MapPin />} title="Endereço" />
            <div style={styles.grid2} className="os-grid-2">
              <Field label="CEP"><input className="os-field" style={styles.input} value={form.cep} onChange={(e) => update('cep', masks.cep(e.target.value))} onBlur={checkCEP} placeholder="00000-000" maxLength={9} /></Field>
              <Field label="Número"><input className="os-field" style={styles.input} value={form.numero} onChange={(e) => update('numero', e.target.value)} placeholder="Nº" /></Field>
              <Field label="Logradouro" span2><input className="os-field" style={styles.input} value={form.endereco} onChange={(e) => update('endereco', e.target.value)} placeholder="Rua, avenida..." /></Field>
              <Field label="Bairro"><input className="os-field" style={styles.input} value={form.bairro} onChange={(e) => update('bairro', e.target.value)} /></Field>
              <div style={styles.grid2}>
                 <Field label="Cidade"><input className="os-field" style={styles.input} value={form.cidade} onChange={(e) => update('cidade', e.target.value)} /></Field>
                 <Field label="UF"><input className="os-field" style={styles.input} value={form.uf} onChange={(e) => update('uf', e.target.value)} /></Field>
              </div>
            </div>
          </div>

          {/* SESSÃO ITENS DO PEDIDO (COM MEDIDAS, ORIGEM, FORMATO, ETC) */}
          <div style={styles.card} className="os-section-row">
            <SectionTitle icon={<Icons.Glasses />} title="Itens do pedido" subtitle="Receita, lente e armação" />

            {form.itens.map((item, index) => {
              const inputBaseIndex = index * 20;
              return (
                <div key={index} style={styles.itemCard} className="os-item-panel">
                  <div style={styles.itemCardHeader}>
                    <h4 style={styles.itemTitle}>Óculos {index + 1}</h4>
                    <div style={styles.itemActions} className="os-actions">
                      {index > 0 && (
                        <>
                          <button type="button" style={styles.btnMini} onClick={() => copiarDadosDoPrimeiroOculos(index)}><Icons.Copy /> Copiar</button>
                          <button type="button" style={styles.btnMiniDanger} onClick={() => removerOculos(index)}><Icons.Trash /> Remover</button>
                        </>
                      )}
                    </div>
                  </div>

                  <Field label="Paciente" required error={errors[`item_${index}_paciente`]}>
                    <input className="os-field" style={{ ...styles.input, ...(errors[`item_${index}_paciente`] ? styles.inputError : {}) }} value={item.paciente} onChange={(e) => updateItem(index, 'paciente', e.target.value)} placeholder="Nome de quem usará este óculos" />
                  </Field>

                  <div style={{ marginTop: 12 }}>
                    <div style={styles.subLabel}>Receita</div>
                    <div style={styles.receitaCard} className="os-receita-card">
                      <div style={styles.receitaHeader}>
                        <div style={{ width: 24 }}></div>
                        {['ESF', 'CIL', 'EIXO', 'DNP', 'ALT'].map((h) => <div key={h} style={styles.colHeader}>{h}</div>)}
                      </div>
                      <ReceitaRow label="OD" color="#2563eb" values={item.receita.od} baseIndex={inputBaseIndex} onChange={(f, v) => updateItem(index, `receita.od.${f}`, v)} onEnter={handleEnterNavigation} />
                      <div style={styles.rowDivider}></div>
                      <ReceitaRow label="OE" color="#dc2626" values={item.receita.oe} baseIndex={inputBaseIndex + 5} onChange={(f, v) => updateItem(index, `receita.oe.${f}`, v)} onEnter={handleEnterNavigation} />
                    </div>
                  </div>

                  <div style={{ ...styles.grid2, marginTop: 12 }} className="os-grid-2">
                     <Field label="Adição (+)">
                        <input data-idx={inputBaseIndex + 10} className="os-field" style={styles.input} value={item.receita.adicao} onChange={(e) => updateItem(index, 'receita.adicao', e.target.value)} onBlur={(e) => updateItem(index, 'receita.adicao', formatters.adicao(e.target.value))} placeholder="+0,00" />
                     </Field>
                     <Field label="Código CV (Lab)">
                        <input className="os-field" style={styles.input} value={item.cv} onChange={(e) => updateItem(index, 'cv', e.target.value)} placeholder="Controle" />
                     </Field>
                  </div>

                  <div style={styles.divisorAba}>Produto</div>

                  <div style={{ ...styles.grid2, marginBottom: 12 }} className="os-grid-2">
                    <Field label="Lente" required error={errors[`item_${index}_lente`]}>
                      <div style={styles.searchWrap}>
                        <input className="os-field" style={{ ...styles.input, ...(errors[`item_${index}_lente`] ? styles.inputError : {}) }} value={item.lente} onChange={(e) => handleLenteSearch(e.target.value, index)} onFocus={() => item.lente.length >= 2 && setShowLenteSuggestionsIndex(index)} placeholder="Buscar lente..." />
                        {isSearchingLente && showLenteSuggestionsIndex === index ? <div style={styles.miniLoader}></div> : <span style={styles.searchIcon}><Icons.Search /></span>}
                      </div>
                      {showLenteSuggestionsIndex === index && lenteSuggestions.length > 0 && (
                        <div style={styles.suggestions}>
                          {lenteSuggestions.map((sug) => <div key={sug._id} style={styles.suggestionItem} onClick={() => selectLente(sug, index)}><div style={styles.suggestionMain}>{sug.nome}</div></div>)}
                        </div>
                      )}
                    </Field>

                    <Field label="Armação (Ref/Marca)" required error={errors[`item_${index}_armacao`]}>
                      <div style={styles.searchWrap}>
                        <input className="os-field" style={{ ...styles.input, ...(errors[`item_${index}_armacao`] ? styles.inputError : {}) }} value={item.armacao} onChange={(e) => handleArmacaoSearch(e.target.value, index)} onFocus={() => item.armacao.length >= 2 && setShowSuggestionsIndex(index)} placeholder="Buscar armação..." />
                        {isSearchingStock && showSuggestionsIndex === index ? <div style={styles.miniLoader}></div> : <span style={styles.searchIcon}><Icons.Search /></span>}
                      </div>

                      {showSuggestionsIndex === index && armacaoSuggestions.length > 0 && (
                        <div style={styles.suggestions}>
                          {armacaoSuggestions.map((sug) => (
                            <div
                              key={sug._id}
                              style={styles.suggestionItem}
                              onClick={() => selectArmacao(sug, index)}
                            >
                              <div style={styles.suggestionMain}>{sug.marca} - {sug.ref}</div>
                              <div style={styles.suggestionSub}>
                                {sug.cor || 'Sem cor'} · {formatCurrency(Number(sug.preco || 0))} · Estoque: {sug.qtd || 0}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {(item.armacaoImagemBlob || Number(item.armacaoPreco || 0) > 0) ? (
                        <div style={styles.armacaoStockPreview}>
                          {item.armacaoImagemBlob ? (
                            <img
                              src={item.armacaoImagemBlob}
                              alt={item.armacao || 'Armação selecionada'}
                              style={styles.armacaoStockPreviewImg}
                              onClick={() => window.open(item.armacaoImagemBlob, '_blank')}
                            />
                          ) : (
                            <div style={styles.armacaoStockPreviewEmpty}>
                              <Icons.Glasses />
                            </div>
                          )}

                          <div style={styles.armacaoStockPreviewInfo}>
                            <strong>{item.armacao || 'Armação selecionada'}</strong>
                            <span>Preço puxado do estoque: {formatCurrency(Number(item.armacaoPreco || 0))}</span>
                            {item.armacaoImagemBlob ? <small>Clique na imagem para ampliar. A foto também foi adicionada aos anexos.</small> : null}
                          </div>
                        </div>
                      ) : null}
                    </Field>
                  </div>

                  <div style={{ ...styles.grid2, marginBottom: 12 }} className="os-grid-2">
                    <Field label="Origem da Armação">
                       <select className="os-field" style={styles.input} value={item.origemArmacao} onChange={(e) => updateItem(index, 'origemArmacao', e.target.value)}>
                          <option>Ótica</option>
                          <option>Própria do Cliente</option>
                       </select>
                    </Field>
                    <Field label="Logística (Onde está?)">
                       <select className="os-field" style={styles.input} value={item.envioArmacao} onChange={(e) => updateItem(index, 'envioArmacao', e.target.value)}>
                          <option>Vai no malote</option>
                          <option>Fica na loja (Já na óptica)</option>
                          <option>Não enviar para lab (Apenas Lente)</option>
                       </select>
                    </Field>
                  </div>

                  <div style={styles.subLabel}>Medidas da Armação</div>
                  <div style={styles.grid4} className="os-grid-4">
                     <Field label="Aro"><input className="os-field" style={styles.inputMini} value={item.medidasArmacao.aro} onChange={(e) => updateItem(index, 'medidasArmacao.aro', e.target.value)} placeholder="00" /></Field>
                     <Field label="Ponte"><input className="os-field" style={styles.inputMini} value={item.medidasArmacao.ponte} onChange={(e) => updateItem(index, 'medidasArmacao.ponte', e.target.value)} placeholder="00" /></Field>
                     <Field label="Altura"><input className="os-field" style={styles.inputMini} value={item.medidasArmacao.altura} onChange={(e) => updateItem(index, 'medidasArmacao.altura', e.target.value)} placeholder="00" /></Field>
                     <Field label="Diagonal"><input className="os-field" style={styles.inputMini} value={item.medidasArmacao.diagonalMaior} onChange={(e) => updateItem(index, 'medidasArmacao.diagonalMaior', e.target.value)} placeholder="00" /></Field>
                  </div>

                  <div style={{...styles.subLabel, marginTop: 12}}>Formato da Armação</div>
                  <div style={styles.shapeGrid} className="os-shapes">
                     {formatos.map(({ id, label, Icon }) => {
                        const isSelected = item.formatoArmacao === id;
                        return (
                           <div key={id} onClick={() => updateItem(index, 'formatoArmacao', id)} style={isSelected ? styles.shapeCardActive : styles.shapeCard}>
                              <div style={styles.shapeIconWrap}><Icon /></div>
                              <span style={styles.shapeLabel}>{label}</span>
                           </div>
                        );
                     })}
                  </div>

                </div>
              );
            })}
            <button type="button" style={styles.btnAddItem} onClick={addNovoOculos}><Icons.Plus /> Adicionar óculos</button>
          </div>

          <div style={styles.card} className="os-section-row">
             <SectionTitle icon={<Icons.Dollar />} title="Financeiro" />
             <div style={styles.grid2} className="os-grid-2">
                 <Field label="Valor total do pedido (R$)">
                    <input className="os-field" style={styles.inputStrong} value={form.valorTotal} onChange={(e) => update('valorTotal', e.target.value)} placeholder="0,00" />
                 </Field>
             </div>

             <div style={{ ...styles.financeWrap, marginTop: 12 }} className="os-finance">
                 <Field label="Forma de Pagto">
                    <select className="os-field" style={styles.input} value={novoPagamento.metodo} onChange={(e) => setNovoPagamento({ ...novoPagamento, metodo: e.target.value })}>
                       {metodosPagamento.map((m) => <option key={m}>{m}</option>)}
                    </select>
                 </Field>
                 {novoPagamento.metodo === 'Crédito' && (
                    <Field label="Parcelas"><input className="os-field" type="number" min="1" max="12" style={styles.input} value={novoPagamento.parcelas} onChange={(e) => setNovoPagamento({ ...novoPagamento, parcelas: e.target.value })} /></Field>
                 )}
                 <Field label="Valor pago"><input className="os-field" style={styles.input} value={novoPagamento.valor} onChange={(e) => setNovoPagamento({ ...novoPagamento, valor: e.target.value })} placeholder="0,00" /></Field>
                 <button type="button" style={styles.btnSecondary} onClick={addPayment}>Inserir</button>
             </div>

             <div style={styles.paymentList}>
                 {form.pagamentos.map((p) => (
                    <div key={p.id} style={styles.paymentItem}>
                       <div><div style={styles.paymentMethod}>{p.metodo} {p.parcelas > 1 ? `(${p.parcelas}x)` : ''}</div><div style={styles.paymentValue}>{formatCurrency(p.valor)}</div></div>
                       <button type="button" style={styles.iconBtnDanger} onClick={() => removePayment(p.id)}><Icons.Trash /></button>
                    </div>
                 ))}
             </div>
             
             <div style={styles.summaryBox}>
                <div style={styles.summaryRow}><span>Total</span><strong>{formatCurrency(valorTotalNum)}</strong></div>
                <div style={styles.summaryRow}><span>Recebido</span><strong style={{ color: '#16a34a' }}>{formatCurrency(totalPago)}</strong></div>
                <div style={styles.summaryDivider}></div>
                <div style={styles.summaryRow}><span>Saldo</span><strong style={{ color: restante > 0.01 ? '#dc2626' : '#16a34a' }}>{restante <= 0.01 ? 'QUITADO' : formatCurrency(restante)}</strong></div>
             </div>
          </div>

          <div style={styles.card} className="os-section-row">
            <SectionTitle
              icon={<Icons.Camera />}
              title="Anexos e receitas"
              subtitle="A foto da armação selecionada entra automaticamente no card 3."
            />

            <div style={styles.photoGuide} className="os-photo-guide">
              {PHOTO_STEPS.map((step, index) => {
                const StepIcon = step.Icon;
                const concluido = Boolean(form.anexos[index] || localPreviewMap[index]);

                return (
                  <div key={step.title} style={concluido ? styles.photoGuideStepDone : styles.photoGuideStep}>
                    <span style={styles.photoGuideNumber}>{index + 1}</span>
                    <StepIcon />
                    <strong>{step.title}</strong>
                  </div>
                );
              })}
            </div>

            <div style={styles.anexoTop}>
               <button type="button" style={styles.btnGhostBlue} onClick={openMobileCamera}><Icons.Smartphone /> Celular</button>
               <button type="button" style={styles.btnGhost} onClick={addImageSlot}><Icons.Plus /> Espaço extra</button>
            </div>

            <div style={styles.photoGrid} className="os-anexos">
               {form.anexos.map((img, index) => {
                  const step = getPhotoStep(index);
                  const StepIcon = step.Icon;
                  const previewSrc = localPreviewMap[index] || img;
                  const preenchido = Boolean(previewSrc);

                  return (
                    <div key={index} style={preenchido ? styles.photoSlotFilled : styles.photoSlot}>
                      <div style={styles.photoSlotHeader}>
                        <div style={styles.photoSlotTitleWrap}>
                          <span style={styles.photoSlotNumber}>{index + 1}</span>
                          <div>
                            <strong style={styles.photoSlotTitle}>{step.title}</strong>
                            <span style={styles.photoSlotSubtitle}>{step.subtitle}</span>
                          </div>
                        </div>
                      </div>

                      {preenchido ? (
                        <div style={styles.photoPreviewWrap}>
                          <ProtectedImage
                            src={previewSrc}
                            alt={step.title}
                            style={styles.previewImg}
                            fallbackIcon={<StepIcon />}
                            fallbackText={step.title}
                          />

                          <div style={styles.previewFooter}>
                            <span>{localPreviewMap[index] ? 'Preview local' : 'Salvo na VPS'}</span>
                          </div>

                          <button
                            type="button"
                            style={styles.removeImgBtn}
                            onClick={() => removeImage(index)}
                            title="Remover imagem"
                          >
                            <Icons.Trash />
                          </button>
                        </div>
                      ) : (
                        <label style={styles.uploadLabel}>
                          <div style={styles.uploadIconCircle}>
                            <StepIcon />
                          </div>
                          <span style={styles.uploadText}>{step.title}</span>
                          <small style={styles.uploadHint}>{step.subtitle}</small>
                          <strong style={styles.uploadAction}>Selecionar imagem</strong>

                          <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            disabled={compressing}
                            onChange={(e) => handleFileChange(index, e.target.files[0])}
                          />
                        </label>
                      )}
                    </div>
                  );
               })}
            </div>
          </div>

          <div style={styles.card} className="os-section-row">
            <SectionTitle icon={<Icons.FileText />} title="Observações" />
            <textarea className="os-field" style={styles.textArea} value={form.novoTextoRegistro} onChange={(e) => update('novoTextoRegistro', e.target.value)} placeholder="Anotações sobre a venda, exigências do cliente..." />
          </div>
        </div>
      </div>

      <div style={styles.footer} className="os-footer">
        <button type="button" style={styles.btnGhost} onClick={onCancel} disabled={loading || compressing}>Cancelar</button>
        <button type="button" style={styles.btnPrimary} onClick={handleSubmit} disabled={loading || compressing || loadingEmpresas || loadingUsuarios}>
          {loading ? 'Salvando...' : 'Salvar pedido'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  shell: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: '100vh',
    background: '#f8fafd',
    borderRadius: 16,
    overflow: 'hidden',
    border: '1px solid #edf0f3',
    boxShadow: 'none'
  },

  topBar: {
    padding: '14px 16px 12px',
    borderBottom: '1px solid #edf0f3',
    background: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },

  topBarMain: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 14
  },

  kicker: {
    display: 'block',
    width: 'fit-content',
    marginBottom: 5,
    color: '#5f6368',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '.04em',
    textTransform: 'uppercase'
  },

  title: {
    margin: 0,
    color: '#202124',
    fontSize: 24,
    lineHeight: 1.15,
    letterSpacing: '-0.035em',
    fontWeight: 600
  },

  headerSubtitle: {
    marginTop: 4,
    color: '#5f6368',
    fontSize: 12.5,
    lineHeight: 1.35
  },

  topBarRight: {
    display: 'flex',
    gap: 8,
    alignItems: 'stretch'
  },

  lojaTopPanel: {
    width: '100%',
    padding: 12,
    border: '1px solid #edf0f3',
    borderRadius: 14,
    background: '#f8fafd'
  },

  lojaTopPanelError: {
    borderColor: '#d93025',
    background: '#fff7f7'
  },

  lojaTopHeader: {
    marginBottom: 10,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12
  },

  lojaTopKicker: {
    color: '#5f6368',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '.055em',
    textTransform: 'uppercase'
  },

  lojaTopTitle: {
    marginTop: 4,
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    color: '#202124',
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: '-0.025em'
  },

  lojaTopSubtitle: {
    marginTop: 2,
    color: '#5f6368',
    fontSize: 12,
    lineHeight: 1.35
  },

  lojaTopMeta: {
    minWidth: 92,
    padding: '8px 10px',
    border: '1px solid #dadce0',
    borderRadius: 12,
    background: '#ffffff',
    color: '#5f6368',
    fontSize: 11,
    fontWeight: 600,
    textAlign: 'center'
  },

  lojaTopGrid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(180px, 1.1fr) minmax(180px, 1fr) minmax(180px, 1.2fr)',
    gap: 10,
    alignItems: 'end'
  },

  lojaMiniInfo: {
    minHeight: 38,
    padding: '7px 9px',
    border: '1px solid #edf0f3',
    borderRadius: 11,
    background: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 4,
    overflow: 'hidden'
  },

  lojaMiniItem: {
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    color: '#5f6368',
    fontSize: 11.5,
    lineHeight: 1.25,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  statusCard: {
    minWidth: 178,
    padding: '8px 10px',
    border: '1px solid #edf0f3',
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    background: '#ffffff'
  },

  statusLabel: {
    color: '#5f6368',
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: '.035em',
    textTransform: 'uppercase'
  },

  toggleBtn: {
    minHeight: 32,
    border: '1px solid #d2e3fc',
    background: '#eef5ff',
    color: '#1a73e8',
    borderRadius: 999,
    padding: '0 12px',
    fontSize: 12,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    cursor: 'pointer'
  },

  toggleBtnActive: {
    background: '#f1f8f4',
    borderColor: '#cce8d5',
    color: '#188038'
  },

  topSelect: {
    width: '100%',
    minHeight: 32,
    border: '1px solid #dadce0',
    background: '#ffffff',
    borderRadius: 9,
    padding: '0 9px',
    color: '#202124',
    fontSize: 12,
    fontWeight: 500,
    outline: 'none'
  },

  body: {
    flex: 1,
    overflowY: 'auto',
    padding: 12,
    background: '#f8fafd'
  },

  errorBanner: {
    marginBottom: 10,
    padding: '10px 12px',
    border: '1px solid #f4c7c3',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: '#d93025',
    background: '#fceeee',
    fontSize: 13,
    fontWeight: 600
  },

  mainStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    animation: 'osFadeUp 0.24s ease both'
  },

  card: {
    padding: 14,
    border: '1px solid #edf0f3',
    borderRadius: 14,
    background: '#ffffff',
    boxShadow: 'none'
  },

  sectionTitleWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 14
  },

  sectionIcon: {
    width: 32,
    height: 32,
    borderRadius: 10,
    border: '1px solid #d2e3fc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#1a73e8',
    background: '#eef5ff',
    flexShrink: 0
  },

  sectionTitle: {
    color: '#202124',
    fontSize: 15,
    fontWeight: 600,
    letterSpacing: '-0.02em',
    lineHeight: 1.2
  },

  sectionSubtitle: {
    marginTop: 2,
    color: '#5f6368',
    fontSize: 12,
    lineHeight: 1.35
  },

  grid2: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10
  },

  grid4: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 8
  },

  fieldWrap: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },

  fieldWrapError: {},

  span2: {
    gridColumn: '1 / -1'
  },

  label: {
    color: '#5f6368',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '.02em'
  },

  labelError: {
    color: '#d93025'
  },

  input: {
    width: '100%',
    minHeight: 38,
    border: '1px solid #dadce0',
    background: '#ffffff',
    borderRadius: 10,
    padding: '0 10px',
    color: '#202124',
    fontSize: 13,
    fontWeight: 400,
    boxSizing: 'border-box',
    outline: 'none'
  },

  inputMini: {
    width: '100%',
    minHeight: 36,
    border: '1px solid #dadce0',
    background: '#ffffff',
    borderRadius: 9,
    padding: '0 8px',
    color: '#202124',
    fontSize: 13,
    fontWeight: 500,
    boxSizing: 'border-box',
    textAlign: 'center',
    outline: 'none'
  },

  inputStrong: {
    width: '100%',
    minHeight: 40,
    border: '1px solid #dadce0',
    background: '#ffffff',
    borderRadius: 10,
    padding: '0 11px',
    color: '#202124',
    fontSize: 15,
    fontWeight: 600,
    boxSizing: 'border-box',
    outline: 'none'
  },

  inputError: {
    border: '1px solid #d93025',
    background: '#fceeee'
  },

  miniLoader: {
    width: 14,
    height: 14,
    border: '2px solid #d2e3fc',
    borderTop: '2px solid #1a73e8',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    position: 'absolute',
    right: 10
  },

  empresaCard: {
    marginTop: 12,
    padding: 12,
    border: '1px solid #edf0f3',
    borderRadius: 12,
    background: '#f8fafd'
  },

  empresaCardHeader: {
    marginBottom: 9,
    display: 'flex',
    justifyContent: 'space-between',
    gap: 8,
    alignItems: 'center',
    flexWrap: 'wrap'
  },

  empresaName: {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    color: '#202124',
    fontSize: 13,
    fontWeight: 600
  },

  unitBadge: {
    padding: '3px 8px',
    border: '1px solid #dadce0',
    borderRadius: 999,
    color: '#5f6368',
    background: '#ffffff',
    fontSize: 11,
    fontWeight: 500
  },

  empresaInfoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 8
  },

  empresaInfoItem: {
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    color: '#5f6368',
    fontSize: 12,
    lineHeight: 1.35,
    overflow: 'hidden'
  },

  itemCard: {
    marginTop: 12,
    padding: 12,
    border: '1px solid #edf0f3',
    borderRadius: 12,
    background: '#ffffff'
  },

  itemCardHeader: {
    marginBottom: 10,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10
  },

  itemTitle: {
    margin: 0,
    color: '#202124',
    fontSize: 14,
    fontWeight: 600
  },

  itemActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },

  subLabel: {
    marginBottom: 7,
    color: '#5f6368',
    fontSize: 12,
    fontWeight: 600
  },

  receitaCard: {
    border: '1px solid #dadce0',
    borderRadius: 12,
    overflow: 'hidden',
    background: '#ffffff'
  },

  receitaHeader: {
    minHeight: 32,
    padding: '0 8px',
    borderBottom: '1px solid #edf0f3',
    display: 'grid',
    gridTemplateColumns: '34px repeat(5, 1fr)',
    alignItems: 'center',
    gap: 6,
    background: '#f8fafd'
  },

  receitaRow: {
    padding: '8px',
    display: 'grid',
    gridTemplateColumns: '34px repeat(5, 1fr)',
    alignItems: 'center',
    gap: 6
  },

  colHeader: {
    color: '#5f6368',
    fontSize: 10,
    fontWeight: 600,
    textAlign: 'center'
  },

  olhoBadge: {
    width: 25,
    height: 25,
    borderRadius: 999,
    display: 'grid',
    placeItems: 'center',
    color: '#ffffff',
    fontSize: 10,
    fontWeight: 700
  },

  tdInput: {
    width: '100%',
    minHeight: 32,
    border: '1px solid #dadce0',
    borderRadius: 8,
    padding: '0 5px',
    color: '#202124',
    background: '#ffffff',
    fontSize: 12,
    fontWeight: 500,
    textAlign: 'center',
    outline: 'none',
    boxSizing: 'border-box'
  },

  rowDivider: {
    height: 1,
    background: '#edf0f3'
  },

  divisorAba: {
    margin: '14px 0 10px',
    paddingTop: 12,
    borderTop: '1px solid #edf0f3',
    color: '#202124',
    fontSize: 13,
    fontWeight: 600
  },

  searchWrap: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },

  searchIcon: {
    position: 'absolute',
    right: 10,
    color: '#80868b',
    display: 'grid',
    placeItems: 'center'
  },

  suggestions: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '100%',
    zIndex: 20,
    marginTop: 5,
    border: '1px solid #dadce0',
    borderRadius: 12,
    overflow: 'hidden',
    background: '#ffffff'
  },

  suggestionItem: {
    padding: '9px 10px',
    borderBottom: '1px solid #edf0f3',
    color: '#202124',
    fontSize: 13,
    cursor: 'pointer'
  },

  suggestionMain: {
    fontWeight: 500
  },

  suggestionSub: {
    marginTop: 3,
    color: '#5f6368',
    fontSize: 11,
    lineHeight: 1.35
  },

  armacaoStockPreview: {
    marginTop: 8,
    padding: 8,
    border: '1px solid #edf0f3',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    background: '#f8fafd'
  },

  armacaoStockPreviewImg: {
    width: 64,
    height: 48,
    border: '1px solid #dadce0',
    borderRadius: 10,
    objectFit: 'cover',
    background: '#ffffff',
    cursor: 'zoom-in'
  },

  armacaoStockPreviewEmpty: {
    width: 64,
    height: 48,
    border: '1px dashed #dadce0',
    borderRadius: 10,
    display: 'grid',
    placeItems: 'center',
    color: '#5f6368',
    background: '#ffffff'
  },

  armacaoStockPreviewInfo: {
    minWidth: 0,
    display: 'grid',
    gap: 2,
    color: '#202124',
    fontSize: 12,
    lineHeight: 1.35
  },

  shapeGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 8
  },

  shapeCard: {
    minHeight: 58,
    padding: 8,
    border: '1px solid #dadce0',
    borderRadius: 12,
    display: 'grid',
    placeItems: 'center',
    gap: 5,
    color: '#5f6368',
    background: '#ffffff',
    cursor: 'pointer'
  },

  shapeCardActive: {
    minHeight: 58,
    padding: 8,
    border: '1px solid #1a73e8',
    borderRadius: 12,
    display: 'grid',
    placeItems: 'center',
    gap: 5,
    color: '#1a73e8',
    background: '#eef5ff',
    cursor: 'pointer'
  },

  shapeIconWrap: {
    display: 'grid',
    placeItems: 'center'
  },

  shapeLabel: {
    fontSize: 11,
    fontWeight: 600
  },

  btnMini: {
    minHeight: 30,
    padding: '0 9px',
    border: '1px solid #dadce0',
    borderRadius: 999,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    color: '#202124',
    background: '#ffffff',
    fontSize: 12,
    fontWeight: 500,
    cursor: 'pointer'
  },

  btnMiniDanger: {
    minHeight: 30,
    padding: '0 9px',
    border: '1px solid #f4c7c3',
    borderRadius: 999,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    color: '#d93025',
    background: '#fceeee',
    fontSize: 12,
    fontWeight: 500,
    cursor: 'pointer'
  },

  btnAddItem: {
    width: '100%',
    minHeight: 38,
    marginTop: 12,
    border: '1px dashed #dadce0',
    borderRadius: 12,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    color: '#1a73e8',
    background: '#ffffff',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer'
  },

  financeWrap: {
    display: 'flex',
    alignItems: 'end',
    gap: 10
  },

  btnSecondary: {
    height: 38,
    padding: '0 13px',
    border: '1px solid #111318',
    borderRadius: 999,
    color: '#ffffff',
    background: '#111318',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer'
  },

  paymentList: {
    display: 'grid',
    gap: 6,
    marginTop: 12
  },

  paymentItem: {
    padding: '9px 10px',
    border: '1px solid #edf0f3',
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
    background: '#f8fafd'
  },

  paymentMethod: {
    color: '#202124',
    fontSize: 13,
    fontWeight: 600
  },

  paymentValue: {
    marginTop: 2,
    color: '#5f6368',
    fontSize: 12
  },

  iconBtnDanger: {
    width: 30,
    height: 30,
    border: '1px solid #f4c7c3',
    borderRadius: 999,
    display: 'grid',
    placeItems: 'center',
    color: '#d93025',
    background: '#ffffff',
    cursor: 'pointer'
  },

  summaryBox: {
    marginTop: 12,
    padding: 12,
    border: '1px solid #dadce0',
    borderRadius: 12,
    background: '#ffffff'
  },

  summaryRow: {
    minHeight: 26,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    color: '#5f6368',
    fontSize: 13
  },

  summaryDivider: {
    height: 1,
    margin: '6px 0',
    background: '#edf0f3'
  },

  anexoTop: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 10
  },

  btnGhostBlue: {
    minHeight: 34,
    padding: '0 11px',
    border: '1px solid #d2e3fc',
    borderRadius: 999,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 7,
    color: '#1a73e8',
    background: '#eef5ff',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer'
  },

  btnGhost: {
    minHeight: 34,
    padding: '0 11px',
    border: '1px solid #dadce0',
    borderRadius: 999,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    color: '#202124',
    background: '#ffffff',
    fontSize: 12,
    fontWeight: 500,
    cursor: 'pointer'
  },

  photoGuide: {
    marginBottom: 12,
    display: 'grid',
    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
    gap: 6
  },

  photoGuideStep: {
    minHeight: 58,
    padding: '8px 7px',
    border: '1px solid #edf0f3',
    borderRadius: 12,
    display: 'grid',
    justifyItems: 'center',
    alignContent: 'center',
    gap: 4,
    color: '#5f6368',
    background: '#f8fafd',
    fontSize: 10.5,
    fontWeight: 650,
    textAlign: 'center'
  },

  photoGuideStepDone: {
    minHeight: 58,
    padding: '8px 7px',
    border: '1px solid #cce8d5',
    borderRadius: 12,
    display: 'grid',
    justifyItems: 'center',
    alignContent: 'center',
    gap: 4,
    color: '#188038',
    background: '#f1f8f4',
    fontSize: 10.5,
    fontWeight: 650,
    textAlign: 'center'
  },

  photoGuideNumber: {
    width: 17,
    height: 17,
    borderRadius: 999,
    display: 'grid',
    placeItems: 'center',
    color: '#ffffff',
    background: '#1a73e8',
    fontSize: 10,
    fontWeight: 800
  },

  photoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
    gap: 8
  },

  photoSlot: {
    position: 'relative',
    minHeight: 178,
    border: '1px dashed #dadce0',
    borderRadius: 14,
    overflow: 'hidden',
    background: '#ffffff',
    animation: 'photoCardIn .18s ease both'
  },

  photoSlotFilled: {
    position: 'relative',
    minHeight: 178,
    border: '1px solid #d2e3fc',
    borderRadius: 14,
    overflow: 'hidden',
    background: '#ffffff',
    animation: 'photoCardIn .18s ease both'
  },

  photoSlotHeader: {
    minHeight: 46,
    padding: '8px 9px',
    borderBottom: '1px solid #edf0f3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#ffffff'
  },

  photoSlotTitleWrap: {
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 7
  },

  photoSlotNumber: {
    width: 19,
    height: 19,
    borderRadius: 999,
    display: 'grid',
    placeItems: 'center',
    color: '#1a73e8',
    background: '#eef5ff',
    border: '1px solid #d2e3fc',
    fontSize: 10,
    fontWeight: 800,
    flexShrink: 0
  },

  photoSlotTitle: {
    display: 'block',
    color: '#202124',
    fontSize: 11,
    fontWeight: 750,
    lineHeight: 1.1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  photoSlotSubtitle: {
    display: 'block',
    marginTop: 2,
    color: '#80868b',
    fontSize: 10,
    fontWeight: 500,
    lineHeight: 1.1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  uploadLabel: {
    height: 'calc(100% - 46px)',
    minHeight: 132,
    padding: 10,
    display: 'grid',
    justifyItems: 'center',
    alignContent: 'center',
    gap: 5,
    color: '#80868b',
    cursor: 'pointer',
    textAlign: 'center'
  },

  uploadIconCircle: {
    width: 48,
    height: 48,
    borderRadius: 16,
    border: '1px solid #d2e3fc',
    display: 'grid',
    placeItems: 'center',
    color: '#1a73e8',
    background: '#eef5ff',
    animation: 'photoIconFloat 2.8s ease-in-out infinite'
  },

  uploadText: {
    color: '#202124',
    fontSize: 12,
    fontWeight: 750,
    lineHeight: 1.2
  },

  uploadHint: {
    color: '#80868b',
    fontSize: 10.5,
    lineHeight: 1.25,
    fontWeight: 500
  },

  uploadAction: {
    marginTop: 3,
    padding: '3px 8px',
    borderRadius: 999,
    color: '#1a73e8',
    background: '#eef5ff',
    border: '1px solid #d2e3fc',
    fontSize: 10.5,
    fontWeight: 800
  },

  photoPreviewWrap: {
    position: 'relative',
    height: 132,
    background: '#f8fafd'
  },

  previewImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  },

  previewFooter: {
    position: 'absolute',
    left: 7,
    bottom: 7,
    padding: '3px 7px',
    borderRadius: 999,
    color: '#ffffff',
    background: 'rgba(32,33,36,.58)',
    fontSize: 10,
    fontWeight: 700,
    backdropFilter: 'blur(8px)'
  },

  protectedImageFallback: {
    display: 'grid',
    placeItems: 'center',
    alignContent: 'center',
    gap: 6,
    color: '#5f6368',
    background: '#f8fafd',
    fontSize: 10.5,
    fontWeight: 650,
    textAlign: 'center',
    padding: 8
  },

  protectedImageIcon: {
    width: 42,
    height: 42,
    borderRadius: 15,
    border: '1px solid #dadce0',
    display: 'grid',
    placeItems: 'center',
    color: '#1a73e8',
    background: '#ffffff'
  },

  removeImgBtn: {
    position: 'absolute',
    top: 7,
    right: 7,
    width: 28,
    height: 28,
    border: '1px solid rgba(255,255,255,.78)',
    borderRadius: 999,
    display: 'grid',
    placeItems: 'center',
    color: '#ffffff',
    background: 'rgba(32,33,36,.72)',
    cursor: 'pointer'
  },

  textArea: {
    width: '100%',
    minHeight: 92,
    border: '1px solid #dadce0',
    borderRadius: 12,
    padding: 10,
    color: '#202124',
    background: '#ffffff',
    fontSize: 13,
    lineHeight: 1.5,
    resize: 'vertical',
    outline: 'none',
    boxSizing: 'border-box'
  },

  footer: {
    padding: '12px 14px',
    borderTop: '1px solid #dadce0',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    background: '#ffffff'
  },

  btnPrimary: {
    minHeight: 38,
    padding: '0 15px',
    border: '1px solid #111318',
    borderRadius: 999,
    color: '#ffffff',
    background: '#111318',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer'
  },

  overlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 9999,
    padding: 18,
    display: 'grid',
    placeItems: 'center',
    background: 'rgba(32,33,36,.48)'
  },

  modalCard: {
    width: 'min(360px, 100%)',
    border: '1px solid #dadce0',
    borderRadius: 16,
    background: '#ffffff',
    padding: 22,
    textAlign: 'center'
  },

  modalTitle: {
    margin: 0,
    color: '#202124',
    fontSize: 18,
    fontWeight: 600,
    letterSpacing: '-0.025em'
  },

  modalText: {
    margin: '7px 0 0',
    color: '#5f6368',
    fontSize: 13,
    lineHeight: 1.5,
    textAlign: 'center'
  },

  qrBox: {
    margin: '14px auto',
    width: 'fit-content',
    border: '1px solid #dadce0',
    borderRadius: 14,
    padding: 12,
    background: '#ffffff'
  },

  spinner: {
    width: 28,
    height: 28,
    border: '3px solid #d2e3fc',
    borderTop: '3px solid #1a73e8',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 12px'
  },

  progressBg: {
    width: '100%',
    height: 7,
    background: '#edf0f3',
    borderRadius: 999,
    marginTop: 12,
    overflow: 'hidden'
  },

  progressFill: {
    height: '100%',
    background: 'linear-gradient(90deg, #1a73e8 0%, #4285f4 45%, #1a73e8 100%)',
    backgroundSize: '36px 100%',
    borderRadius: 999,
    transition: 'width 0.2s ease',
    animation: 'progressShimmer 0.85s linear infinite'
  },

  progressPercent: {
    marginTop: 8,
    color: '#202124',
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: '-0.01em'
  },

  saveDetail: {
    margin: '4px 0 0',
    color: '#80868b',
    fontSize: 12,
    lineHeight: 1.4,
    textAlign: 'center'
  }
};

Object.assign(styles, {
  shell: {
    ...styles.shell,
    minHeight: '100svh',
    background: '#ffffff',
    borderRadius: 0,
    border: '0',
    boxShadow: 'none'
  },
  topBar: {
    ...styles.topBar,
    padding: '18px 24px 14px',
    borderBottom: '1px solid #e8eaed',
    background: '#ffffff',
    gap: 14
  },
  topBarMain: {
    ...styles.topBarMain,
    maxWidth: 1180,
    width: '100%',
    margin: '0 auto'
  },
  kicker: {
    ...styles.kicker,
    color: '#677083',
    fontSize: 10.5,
    fontWeight: 850
  },
  title: {
    ...styles.title,
    fontSize: 30,
    fontWeight: 850,
    letterSpacing: '-0.05em'
  },
  headerSubtitle: {
    ...styles.headerSubtitle,
    fontSize: 13.5,
    maxWidth: 520
  },
  lojaTopPanel: {
    ...styles.lojaTopPanel,
    maxWidth: 1180,
    margin: '0 auto',
    padding: '14px 0 2px',
    border: '0',
    borderTop: '1px solid #e8eaed',
    borderRadius: 0,
    background: '#ffffff'
  },
  lojaTopMeta: {
    ...styles.lojaTopMeta,
    borderColor: '#e8eaed',
    borderRadius: 12,
    background: '#f8fafd'
  },
  lojaMiniInfo: {
    ...styles.lojaMiniInfo,
    borderColor: '#e8eaed',
    borderRadius: 12,
    background: '#f8fafd'
  },
  statusCard: {
    ...styles.statusCard,
    borderColor: '#e8eaed',
    borderRadius: 14,
    background: '#f8fafd'
  },
  body: {
    ...styles.body,
    padding: '0 24px 94px',
    background: '#ffffff'
  },
  mainStack: {
    ...styles.mainStack,
    maxWidth: 1180,
    width: '100%',
    margin: '0 auto',
    gap: 0
  },
  card: {
    ...styles.card,
    padding: '26px 0',
    border: '0',
    borderBottom: '1px solid #e8eaed',
    borderRadius: 0,
    background: 'transparent',
    boxShadow: 'none'
  },
  sectionTitleWrap: {
    ...styles.sectionTitleWrap,
    marginBottom: 16
  },
  sectionIcon: {
    ...styles.sectionIcon,
    width: 34,
    height: 34,
    borderRadius: 12,
    borderColor: '#e8eaed',
    color: '#1a73e8',
    background: '#f3f7ff'
  },
  sectionTitle: {
    ...styles.sectionTitle,
    fontSize: 17,
    fontWeight: 850
  },
  sectionSubtitle: {
    ...styles.sectionSubtitle,
    fontSize: 12.5
  },
  grid2: {
    ...styles.grid2,
    gap: 12
  },
  grid4: {
    ...styles.grid4,
    gap: 10
  },
  label: {
    ...styles.label,
    fontSize: 11.5,
    fontWeight: 800,
    color: '#677083'
  },
  input: {
    ...styles.input,
    minHeight: 44,
    border: '1px solid #dfe4ec',
    borderRadius: 13,
    padding: '0 13px',
    fontSize: 14,
    fontWeight: 600,
    background: '#ffffff'
  },
  inputMini: {
    ...styles.inputMini,
    minHeight: 42,
    border: '1px solid #dfe4ec',
    borderRadius: 12,
    fontSize: 14,
    background: '#ffffff'
  },
  inputStrong: {
    ...styles.inputStrong,
    minHeight: 46,
    border: '1px solid #dfe4ec',
    borderRadius: 13,
    fontSize: 17,
    fontWeight: 850,
    background: '#ffffff'
  },
  itemCard: {
    ...styles.itemCard,
    marginTop: 16,
    padding: '16px 0 0',
    border: '0',
    borderTop: '1px solid #e8eaed',
    borderRadius: 0,
    background: 'transparent'
  },
  itemTitle: {
    ...styles.itemTitle,
    fontSize: 15,
    fontWeight: 850
  },
  receitaCard: {
    ...styles.receitaCard,
    borderColor: '#e2e8f0',
    borderRadius: 16
  },
  receitaHeader: {
    ...styles.receitaHeader,
    minHeight: 36,
    background: '#f8fafd'
  },
  receitaRow: {
    ...styles.receitaRow,
    padding: 10
  },
  tdInput: {
    ...styles.tdInput,
    minHeight: 38,
    borderRadius: 10,
    fontSize: 13
  },
  btnAddItem: {
    ...styles.btnAddItem,
    width: '100%',
    minHeight: 44,
    marginTop: 14,
    borderRadius: 14,
    borderStyle: 'solid',
    background: '#f8fafd',
    fontWeight: 850
  },
  financeWrap: {
    ...styles.financeWrap,
    gap: 12
  },
  btnSecondary: {
    ...styles.btnSecondary,
    height: 44,
    borderRadius: 14,
    background: '#202124',
    borderColor: '#202124',
    fontWeight: 850
  },
  summaryBox: {
    ...styles.summaryBox,
    borderColor: '#e8eaed',
    borderRadius: 16,
    background: '#f8fafd'
  },
  photoGuide: {
    ...styles.photoGuide,
    gap: 8
  },
  photoGuideStep: {
    ...styles.photoGuideStep,
    borderColor: '#e8eaed',
    background: '#f8fafd'
  },
  photoGuideStepDone: {
    ...styles.photoGuideStepDone,
    borderColor: '#cce8d5'
  },
  photoGrid: {
    ...styles.photoGrid,
    gap: 10
  },
  photoSlot: {
    ...styles.photoSlot,
    borderColor: '#dfe4ec',
    borderRadius: 16
  },
  photoSlotFilled: {
    ...styles.photoSlotFilled,
    borderColor: '#bfd3ff',
    borderRadius: 16
  },
  textArea: {
    ...styles.textArea,
    minHeight: 118,
    borderColor: '#dfe4ec',
    borderRadius: 16,
    padding: 14,
    fontSize: 14
  },
  footer: {
    ...styles.footer,
    position: 'sticky',
    bottom: 0,
    zIndex: 30,
    padding: '12px 24px',
    borderTop: '1px solid #e8eaed',
    background: 'rgba(255,255,255,.96)',
    backdropFilter: 'blur(16px)'
  },
  btnPrimary: {
    ...styles.btnPrimary,
    minHeight: 44,
    padding: '0 18px',
    borderRadius: 14,
    borderColor: '#1a73e8',
    background: '#1a73e8',
    fontWeight: 850
  },
  btnGhost: {
    ...styles.btnGhost,
    minHeight: 42,
    borderRadius: 14,
    fontWeight: 750
  },
  btnGhostBlue: {
    ...styles.btnGhostBlue,
    minHeight: 42,
    borderRadius: 14,
    fontWeight: 850
  },
  modalCard: {
    ...styles.modalCard,
    borderRadius: 22,
    boxShadow: '0 24px 70px rgba(15,23,42,.22)'
  }
});

Object.assign(styles, {
  shell: {
    ...styles.shell,
    minHeight: '100svh',
    background: '#fff',
    border: 0,
    borderRadius: 0,
    boxShadow: 'none'
  },
  topBar: {
    ...styles.topBar,
    padding: '14px 20px 10px',
    borderBottom: '1px solid #e8eaed',
    background: '#fff',
    borderRadius: 0,
    boxShadow: 'none'
  },
  topBarMain: {
    ...styles.topBarMain,
    maxWidth: 'none',
    width: '100%',
    margin: 0
  },
  title: {
    ...styles.title,
    fontSize: 27,
    lineHeight: 1.05,
    fontWeight: 850,
    letterSpacing: '-0.05em'
  },
  headerSubtitle: {
    ...styles.headerSubtitle,
    fontSize: 12.5,
    marginTop: 3
  },
  statusCard: {
    ...styles.statusCard,
    borderRadius: 8,
    border: '1px solid #e8eaed',
    background: '#fff',
    padding: 9,
    boxShadow: 'none'
  },
  toggleBtn: {
    ...styles.toggleBtn,
    minHeight: 34,
    borderRadius: 8,
    fontSize: 12
  },
  topSelect: {
    ...styles.topSelect,
    minHeight: 34,
    height: 34,
    borderRadius: 8,
    fontSize: 12
  },
  lojaTopPanel: {
    ...styles.lojaTopPanel,
    maxWidth: 'none',
    width: '100%',
    margin: 0,
    padding: '10px 0 0',
    border: 0,
    borderTop: '1px solid #e8eaed',
    borderRadius: 0,
    background: '#fff',
    boxShadow: 'none'
  },
  lojaTopMeta: {
    ...styles.lojaTopMeta,
    borderRadius: 8,
    background: '#fff',
    boxShadow: 'none'
  },
  lojaMiniInfo: {
    ...styles.lojaMiniInfo,
    borderRadius: 8,
    background: '#fff',
    boxShadow: 'none'
  },
  body: {
    ...styles.body,
    padding: '0 20px 82px',
    background: '#fff'
  },
  mainStack: {
    ...styles.mainStack,
    maxWidth: 'none',
    width: '100%',
    margin: 0,
    gap: 0
  },
  card: {
    ...styles.card,
    padding: '18px 0',
    border: 0,
    borderBottom: '1px solid #e8eaed',
    borderRadius: 0,
    background: 'transparent',
    boxShadow: 'none'
  },
  sectionTitleWrap: {
    ...styles.sectionTitleWrap,
    marginBottom: 12
  },
  sectionIcon: {
    ...styles.sectionIcon,
    width: 28,
    height: 28,
    borderRadius: 6,
    background: '#f8fafd',
    border: '1px solid #e8eaed',
    color: '#1a73e8'
  },
  sectionTitle: {
    ...styles.sectionTitle,
    fontSize: 15,
    fontWeight: 850
  },
  sectionSubtitle: {
    ...styles.sectionSubtitle,
    fontSize: 11.5
  },
  fieldWrap: {
    ...styles.fieldWrap,
    gap: 4
  },
  label: {
    ...styles.label,
    fontSize: 10.5,
    fontWeight: 800,
    color: '#677083'
  },
  grid2: {
    ...styles.grid2,
    gap: 9
  },
  grid4: {
    ...styles.grid4,
    gap: 8
  },
  input: {
    ...styles.input,
    minHeight: 40,
    height: 40,
    borderRadius: 8,
    border: '1px solid #dfe4ec',
    background: '#fff',
    padding: '0 10px',
    fontSize: 13,
    fontWeight: 600,
    boxShadow: 'none'
  },
  inputMini: {
    ...styles.inputMini,
    minHeight: 38,
    height: 38,
    borderRadius: 8,
    border: '1px solid #dfe4ec',
    background: '#fff',
    fontSize: 13,
    boxShadow: 'none'
  },
  inputStrong: {
    ...styles.inputStrong,
    minHeight: 42,
    height: 42,
    borderRadius: 8,
    border: '1px solid #dfe4ec',
    background: '#fff',
    fontSize: 15,
    fontWeight: 850,
    boxShadow: 'none'
  },
  itemCard: {
    ...styles.itemCard,
    marginTop: 12,
    padding: '12px 0 0',
    border: 0,
    borderTop: '1px solid #e8eaed',
    borderRadius: 0,
    background: 'transparent',
    boxShadow: 'none'
  },
  itemTitle: {
    ...styles.itemTitle,
    fontSize: 14,
    fontWeight: 850
  },
  receitaCard: {
    ...styles.receitaCard,
    borderRadius: 0,
    borderLeft: 0,
    borderRight: 0,
    borderColor: '#e8eaed',
    background: '#fff',
    boxShadow: 'none'
  },
  receitaHeader: {
    ...styles.receitaHeader,
    minHeight: 32,
    background: '#f8fafd',
    borderRadius: 0
  },
  receitaRow: {
    ...styles.receitaRow,
    padding: 8
  },
  tdInput: {
    ...styles.tdInput,
    minHeight: 34,
    height: 34,
    borderRadius: 7,
    fontSize: 12.5
  },
  btnAddItem: {
    ...styles.btnAddItem,
    minHeight: 38,
    borderRadius: 8,
    marginTop: 10,
    background: '#fff',
    border: '1px solid #dfe4ec',
    fontWeight: 850,
    boxShadow: 'none'
  },
  photoGuideStep: {
    ...styles.photoGuideStep,
    borderRadius: 8,
    boxShadow: 'none'
  },
  photoSlot: {
    ...styles.photoSlot,
    borderRadius: 8,
    boxShadow: 'none'
  },
  photoSlotFilled: {
    ...styles.photoSlotFilled,
    borderRadius: 8,
    boxShadow: 'none'
  },
  textArea: {
    ...styles.textArea,
    minHeight: 88,
    borderRadius: 8,
    borderColor: '#dfe4ec',
    background: '#fff',
    padding: 10,
    fontSize: 13,
    boxShadow: 'none'
  },
  summaryBox: {
    ...styles.summaryBox,
    borderRadius: 0,
    borderLeft: 0,
    borderRight: 0,
    background: '#fff',
    boxShadow: 'none'
  },
  footer: {
    ...styles.footer,
    position: 'sticky',
    bottom: 0,
    zIndex: 30,
    padding: '8px 20px',
    borderTop: '1px solid #e8eaed',
    background: 'rgba(255,255,255,.97)',
    backdropFilter: 'blur(14px)',
    boxShadow: 'none',
    borderRadius: 0
  },
  btnPrimary: {
    ...styles.btnPrimary,
    minHeight: 40,
    height: 40,
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 850,
    boxShadow: 'none'
  },
  btnGhost: {
    ...styles.btnGhost,
    minHeight: 40,
    height: 40,
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 750,
    boxShadow: 'none'
  },
  btnGhostBlue: {
    ...styles.btnGhostBlue,
    minHeight: 38,
    height: 38,
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 850,
    boxShadow: 'none'
  },
  modalCard: {
    ...styles.modalCard,
    borderRadius: 10,
    boxShadow: '0 20px 60px rgba(15,23,42,.20)'
  }
});

